var _defs, _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _path9, _path10, _path11, _path12, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKids100X200(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "283.77pt",
    height: "567.23pt",
    viewBox: "0 0 283.77 567.23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3594 4.0938c-0.48047-0.125-0.83984-0.34375-1.0781-0.65625-0.24219-0.30469-0.35938-0.67188-0.35938-1.1094 0-0.71094 0.21875-1.2266 0.65625-1.5469 0.44531-0.3125 0.97656-0.46875 1.5938-0.46875 0.6875 0 1.2227 0.1875 1.6094 0.5625 0.39453 0.375 0.59375 0.85938 0.59375 1.4531 0 0.41406-0.10938 0.76953-0.32812 1.0625-0.21094 0.30078-0.52344 0.51562-0.9375 0.64062l-0.125-0.5625c0.30078-0.09375 0.52344-0.24219 0.67188-0.4375 0.14453-0.1875 0.21875-0.42188 0.21875-0.70312 0-0.46875-0.15625-0.82812-0.46875-1.0781-0.30469-0.24219-0.71094-0.35938-1.2188-0.35938-0.60547 0-1.0547 0.125-1.3438 0.375-0.29297 0.25781-0.4375 0.59766-0.4375 1.0156 0 0.33203 0.085938 0.60156 0.26562 0.8125 0.1875 0.20703 0.46094 0.35156 0.82812 0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.0312v-2.8438c0.23828 0 0.48438 0.082031 0.73438 0.25 0.25 0.16406 0.5625 0.48438 0.9375 0.95312 0.21875 0.28125 0.45312 0.53125 0.70312 0.75 0.25 0.22656 0.5 0.34375 0.75 0.34375 0.21875 0 0.39453-0.078125 0.53125-0.23438 0.14453-0.15625 0.21875-0.35156 0.21875-0.57812 0-0.24219-0.074219-0.44531-0.21875-0.60938-0.13672-0.15625-0.35156-0.23438-0.64062-0.23438l0.0625-0.54688c0.39453 0.039062 0.69531 0.1875 0.90625 0.4375 0.21875 0.25 0.32812 0.56641 0.32812 0.95312 0 0.42578-0.12109 0.75391-0.35938 0.98438-0.23047 0.23828-0.50781 0.35938-0.82812 0.35938-0.28125 0-0.5625-0.10156-0.84375-0.29688-0.28125-0.19922-0.65625-0.59375-1.125-1.1875-0.25-0.3125-0.46484-0.51562-0.64062-0.60938v2.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.5469v-0.54688h3.5938v-0.015625l-3.5938-1.2344v-0.5l3.6562-1.2344v-0.015625h-3.6562v-0.54688h4.2969v0.85938l-3.0469 1.0156c-0.33594 0.11328-0.54297 0.17578-0.625 0.1875v0.015625c0.16406 0.050781 0.39453 0.12891 0.6875 0.23438l2.9844 1.0156v0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.0156v-0.65625l1.3125-0.5v-1.7969l-1.3125-0.46875v-0.59375l4.2969 1.6406v0.60938zm1.7656-1.3281c0.92578-0.35547 1.4531-0.55469 1.5781-0.59375 0.125-0.042969 0.28906-0.089844 0.5-0.14062v-0.015625c-0.29297-0.0625-0.55859-0.13672-0.79688-0.21875l-1.2812-0.48438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.8594v-0.59375l3.375-2.2344v-0.015625h-3.375v-0.54688h4.2969v0.59375l-3.375 2.2344v0.015625h3.375v0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7812 3.5312v-1.4219h-3.7812v-0.5625h3.7812v-1.4219h0.51562v3.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.6875v-3.2188h4.2969v3.1094h-0.51562v-2.5312h-1.3125v2.375h-0.5v-2.375h-1.4531v2.6406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.1406v-2.6875h4.2969v0.5625h-3.7812v2.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.125v-0.57812h4.2969v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 0.48438v1.4844c0 0.25781-0.015625 0.48438-0.046875 0.67188-0.023438 0.1875-0.085938 0.36328-0.1875 0.53125-0.10547 0.16406-0.24609 0.3125-0.42188 0.4375-0.17969 0.13281-0.38672 0.23828-0.625 0.3125-0.23047 0.070313-0.51172 0.10938-0.84375 0.10938-0.63672 0-1.1562-0.15234-1.5625-0.45312-0.40625-0.30469-0.60938-0.82031-0.60938-1.5469v-1.5469zm-3.7812 0.5625v0.92188c0 0.1875 0.007813 0.35156 0.03125 0.5 0.019531 0.14453 0.082031 0.28906 0.1875 0.4375 0.10156 0.15625 0.26953 0.28516 0.5 0.39062 0.23828 0.10156 0.55469 0.15625 0.95312 0.15625 0.20703 0 0.40625-0.023437 0.59375-0.0625 0.1875-0.042969 0.35938-0.11719 0.51562-0.21875 0.15625-0.09375 0.26562-0.21094 0.32812-0.34375 0.070312-0.13672 0.11328-0.26562 0.125-0.39062 0.019531-0.125 0.03125-0.28906 0.03125-0.48438v-0.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 3.9688-4.2969-1.6875v-0.57812l4.2969-1.6719v0.60938l-3.125 1.125c-0.19922 0.082031-0.43359 0.15625-0.70312 0.21875v0.015625c0.22656 0.0625 0.46094 0.13281 0.70312 0.21875l3.125 1.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8125 3.8594c-0.21875 0-0.42188-0.015625-0.60938-0.046875-0.1875-0.023438-0.38281-0.085938-0.57812-0.1875-0.19922-0.10547-0.36719-0.27734-0.5-0.51562-0.13281-0.23047-0.20312-0.54297-0.20312-0.9375 0-0.38672 0.058594-0.69922 0.17188-0.9375 0.125-0.23047 0.27344-0.40234 0.45312-0.51562 0.1875-0.10547 0.37891-0.17188 0.57812-0.20312 0.20703-0.03125 0.4375-0.046875 0.6875-0.046875h2.4844v0.57812h-2.4844c-0.25 0-0.46875 0.015625-0.65625 0.046875-0.1875 0.039062-0.35547 0.14062-0.5 0.29688-0.14844 0.15625-0.21875 0.39844-0.21875 0.73438 0 0.33203 0.054688 0.58203 0.17188 0.75 0.11328 0.16406 0.26562 0.27344 0.45312 0.32812 0.19531 0.050781 0.44531 0.078125 0.75 0.078125h2.4844v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 1.6719-4.4375-1.25v-0.42188l4.4375 1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.375 2.3438c0 0.60156-0.21094 1.0938-0.625 1.4688-0.40625 0.38281-0.94531 0.57812-1.6094 0.57812-0.66797 0-1.2031-0.19531-1.6094-0.57812-0.40625-0.38672-0.60938-0.875-0.60938-1.4688 0-0.625 0.20703-1.125 0.625-1.5 0.42578-0.375 0.94141-0.5625 1.5469-0.5625 0.70703 0 1.2656 0.1875 1.6719 0.5625 0.40625 0.38281 0.60938 0.88281 0.60938 1.5zm-3.9688-0.015625c0 0.4375 0.14844 0.78906 0.45312 1.0625 0.3125 0.26953 0.73828 0.40625 1.2812 0.40625 0.5625 0 0.98828-0.14062 1.2812-0.42188 0.30078-0.27344 0.45312-0.61719 0.45312-1.0312 0-0.42969-0.14844-0.78125-0.4375-1.0625-0.29297-0.27344-0.74609-0.40625-1.3594-0.40625-0.49219 0-0.89062 0.13281-1.2031 0.40625-0.3125 0.26953-0.46875 0.61719-0.46875 1.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.8594v-0.57812h2.0156v-2.2344h-2.0156v-0.5625h4.2969v0.5625h-1.7656v2.2344h1.7656v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0312 3.0156c0.28125-0.023437 0.48828-0.12109 0.625-0.29688 0.13281-0.17969 0.20312-0.42969 0.20312-0.75 0-0.29297-0.058594-0.53125-0.17188-0.71875-0.10547-0.17969-0.26172-0.26562-0.46875-0.26562-0.1875 0-0.32812 0.066406-0.42188 0.20312-0.085937 0.14453-0.17188 0.41406-0.26562 0.8125-0.074219 0.35156-0.15234 0.64453-0.23438 0.875-0.085937 0.22656-0.21484 0.42188-0.39062 0.57812-0.16797 0.15625-0.39844 0.23438-0.6875 0.23438-0.375 0-0.6875-0.14844-0.9375-0.4375-0.24219-0.29297-0.35938-0.67969-0.35938-1.1562 0-0.59375 0.13281-1.043 0.40625-1.3438 0.26953-0.30469 0.61719-0.46484 1.0469-0.48438l0.046875 0.54688c-0.34375 0.019531-0.59375 0.14844-0.75 0.39062-0.15625 0.23828-0.23438 0.53125-0.23438 0.875 0 0.32031 0.0625 0.57812 0.1875 0.76562 0.13281 0.19531 0.31641 0.29688 0.54688 0.29688 0.22656 0 0.39453-0.10547 0.5-0.3125 0.11328-0.19922 0.22266-0.54297 0.32812-1.0312 0.10156-0.48047 0.25-0.82812 0.4375-1.0469 0.1875-0.21094 0.42969-0.3125 0.73438-0.3125 0.34375 0 0.62891 0.13281 0.85938 0.40625 0.22656 0.26953 0.34375 0.64062 0.34375 1.1094s-0.11719 0.84766-0.34375 1.1406c-0.21875 0.28906-0.53906 0.44531-0.95312 0.46875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 0.46875v1.6094c0 0.25781-0.015625 0.47656-0.046875 0.65625-0.023438 0.1875-0.085938 0.35938-0.1875 0.51562-0.10547 0.16406-0.25 0.28516-0.4375 0.35938-0.17969 0.082031-0.37109 0.125-0.57812 0.125-0.39844 0-0.71484-0.13281-0.95312-0.39062-0.24219-0.25-0.35938-0.65625-0.35938-1.2188v-1.0938h-1.7344v-0.5625zm-2.0469 0.5625v1.1094c0 0.67578 0.25781 1.0156 0.78125 1.0156 0.17578 0 0.32812-0.046875 0.45312-0.14062 0.13281-0.085937 0.21875-0.19531 0.25-0.32812 0.03125-0.125 0.046875-0.3125 0.046875-0.5625v-1.0938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2812 2.8906c-0.085938 0.26953-0.21875 0.46875-0.40625 0.59375-0.17969 0.13281-0.38672 0.20312-0.625 0.20312-0.24219 0-0.46484-0.0625-0.67188-0.1875-0.19922-0.11719-0.34375-0.28906-0.4375-0.51562-0.09375-0.21875-0.14062-0.51562-0.14062-0.89062v-1.6406h4.2969v1.6094c0 0.51953-0.11719 0.88281-0.34375 1.0938-0.23047 0.21875-0.48047 0.32812-0.75 0.32812-0.1875 0-0.36719-0.054687-0.53125-0.15625-0.15625-0.09375-0.28906-0.24219-0.39062-0.4375zm0.21875-1.875v0.9375c0 0.1875 0.00781 0.34375 0.03125 0.46875 0.019531 0.13281 0.078125 0.25 0.17188 0.34375 0.09375 0.10156 0.23438 0.15625 0.42188 0.15625 0.20703 0 0.35938-0.054687 0.45312-0.15625 0.09375-0.09375 0.14844-0.21484 0.17188-0.35938 0.019531-0.13672 0.03125-0.3125 0.03125-0.53125v-0.85938zm-1.9844 0v1.0625c0 0.38281 0.0625 0.64844 0.1875 0.79688 0.13281 0.15625 0.31641 0.23438 0.54688 0.23438 0.22656 0 0.40625-0.085937 0.53125-0.25 0.13281-0.15625 0.20312-0.4375 0.20312-0.84375v-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.59375 4.2812c-0.44922-0.54297-0.67188-1.1328-0.67188-1.7656 0-0.66797 0.19531-1.2031 0.59375-1.6094 0.40625-0.39844 0.94141-0.59375 1.6094-0.59375 0.40625 0 0.78516 0.082031 1.1406 0.25 0.35156 0.16406 0.625 0.40625 0.8125 0.71875 0.19531 0.32031 0.29688 0.71875 0.29688 1.1875 0 0.47656-0.10938 0.86328-0.32812 1.1562-0.21094 0.28906-0.52734 0.48828-0.95312 0.59375l-0.14062-0.51562c0.3125-0.074219 0.53906-0.21484 0.6875-0.42188 0.15625-0.21094 0.23438-0.48047 0.23438-0.8125 0-0.52344-0.15625-0.91406-0.46875-1.1719-0.3125-0.26172-0.72656-0.39062-1.2344-0.39062-0.38672 0-0.71094 0.0625-0.96875 0.1875-0.25 0.125-0.44531 0.3125-0.57812 0.5625-0.125 0.25-0.1875 0.52344-0.1875 0.82812 0 0.44531 0.14453 0.86328 0.4375 1.25h0.79688v-1.2656h0.51562v1.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.2656v-0.71875c0.67578-0.42969 1.0938-0.69531 1.25-0.79688 0.15625-0.10547 0.28516-0.21484 0.39062-0.32812 0.11328-0.11719 0.17969-0.22656 0.20312-0.32812 0.03125-0.09375 0.046875-0.22656 0.046875-0.39062v-0.65625h-1.8906v-0.5625h4.2969v1.8906c0 0.25781-0.015625 0.47656-0.046875 0.65625-0.03125 0.17578-0.10547 0.33203-0.21875 0.46875-0.10547 0.13281-0.24219 0.23438-0.40625 0.29688-0.15625 0.070313-0.32422 0.10938-0.5 0.10938-0.32422 0-0.58594-0.10547-0.78125-0.3125-0.19922-0.19922-0.32422-0.49609-0.375-0.89062h-0.015625c-0.125 0.28906-0.38672 0.5625-0.78125 0.8125zm2.4062-3.2188v1.2188c0 0.25 0.019531 0.44141 0.0625 0.57812 0.039062 0.14453 0.11719 0.25781 0.23438 0.34375 0.125 0.09375 0.26562 0.14062 0.42188 0.14062 0.1875 0 0.34766-0.074219 0.48438-0.21875 0.14453-0.14844 0.21875-0.38281 0.21875-0.70312v-1.3594z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.5v-3.3906h0.53125l2.75 2.2031s0.0625 0.050781 0.1875 0.15625c0.125 0.10156 0.22656 0.19531 0.3125 0.28125v-2.3906h0.51562v3.0781h-0.51562l-2.9688-2.4219-0.29688-0.25v2.7344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2969 1.8125v-1.625h0.51562v1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.3281v-3.0469h0.59375l1.6406 1.4062 1.4844-1.4062h0.57812v2.9219h-0.51562v-2.2969l-1.5469 1.4531-1.7188-1.4531v2.4219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.6875v-3.2188h4.2969v3.1094h-0.51562v-2.5312h-1.3125v2.375h-0.5v-2.375h-1.4531v2.6406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7812 3.5312v-1.4219h-3.7812v-0.5625h3.7812v-1.4219h0.51562v3.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 0.46875v1.6094c0 0.25781-0.015625 0.47656-0.046875 0.65625-0.023438 0.1875-0.085938 0.35938-0.1875 0.51562-0.10547 0.16406-0.25 0.28516-0.4375 0.35938-0.17969 0.082031-0.37109 0.125-0.57812 0.125-0.39844 0-0.71484-0.13281-0.95312-0.39062-0.24219-0.25-0.35938-0.65625-0.35938-1.2188v-1.0938h-1.7344v-0.5625zm-2.0469 0.5625v1.1094c0 0.67578 0.25781 1.0156 0.78125 1.0156 0.17578 0 0.32812-0.046875 0.45312-0.14062 0.13281-0.085937 0.21875-0.19531 0.25-0.32812 0.03125-0.125 0.046875-0.3125 0.046875-0.5625v-1.0938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.0156v-0.65625l1.3125-0.5v-1.7969l-1.3125-0.46875v-0.59375l4.2969 1.6406v0.60938zm1.7656-1.3281c0.92578-0.35547 1.4531-0.55469 1.5781-0.59375 0.125-0.042969 0.28906-0.089844 0.5-0.14062v-0.015625c-0.29297-0.0625-0.55859-0.13672-0.79688-0.21875l-1.2812-0.48438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.8594v-0.57812h3.7812v-2.2344h-3.7812v-0.5625h4.2969v3.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.5v-3.3906h0.53125l2.75 2.2031s0.0625 0.050781 0.1875 0.15625c0.125 0.10156 0.22656 0.19531 0.3125 0.28125v-2.3906h0.51562v3.0781h-0.51562l-2.9688-2.4219-0.29688-0.25v2.7344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.375 2.3438c0 0.60156-0.21094 1.0938-0.625 1.4688-0.40625 0.38281-0.94531 0.57812-1.6094 0.57812-0.66797 0-1.2031-0.19531-1.6094-0.57812-0.40625-0.38672-0.60938-0.875-0.60938-1.4688 0-0.625 0.20703-1.125 0.625-1.5 0.42578-0.375 0.94141-0.5625 1.5469-0.5625 0.70703 0 1.2656 0.1875 1.6719 0.5625 0.40625 0.38281 0.60938 0.88281 0.60938 1.5zm-3.9688-0.015625c0 0.4375 0.14844 0.78906 0.45312 1.0625 0.3125 0.26953 0.73828 0.40625 1.2812 0.40625 0.5625 0 0.98828-0.14062 1.2812-0.42188 0.30078-0.27344 0.45312-0.61719 0.45312-1.0312 0-0.42969-0.14844-0.78125-0.4375-1.0625-0.29297-0.27344-0.74609-0.40625-1.3594-0.40625-0.49219 0-0.89062 0.13281-1.2031 0.40625-0.3125 0.26953-0.46875 0.61719-0.46875 1.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.5469v-0.54688h3.5938v-0.015625l-3.5938-1.2344v-0.5l3.6562-1.2344v-0.015625h-3.6562v-0.54688h4.2969v0.85938l-3.0469 1.0156c-0.33594 0.11328-0.54297 0.17578-0.625 0.1875v0.015625c0.16406 0.050781 0.39453 0.12891 0.6875 0.23438l2.9844 1.0156v0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.8594v-0.59375l3.375-2.2344v-0.015625h-3.375v-0.54688h4.2969v0.59375l-3.375 2.2344v0.015625h3.375v0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.125v-0.57812h4.2969v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.9531v-0.60938l3.125-1.1094c0.26953-0.10547 0.50391-0.18359 0.70312-0.23438-0.24219-0.0625-0.47656-0.14062-0.70312-0.23438l-3.125-1.1562v-0.57812l4.2969 1.6875v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 5.6719v-2.8125h1.25v-1.6562l-1.25-0.57812v-0.625l4.2969 2.0781v3.5156h-0.51562v-2.1562h-1.3125v2h-0.5v-2h-1.4688v2.2344zm1.75-2.8125h2.0312v-0.42188l-2.0312-0.98438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.9844v-0.75l2.1719-1.5156-0.6875-0.70312h-1.4844v-0.57812h4.2969v0.57812h-2.125l2.125 2.125v0.76562l-1.7344-1.7969z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.9531 4.9219v-3.9531h0.53125v3.9531zm-1.125 0.3125c-0.074219 0-0.25781-0.089844-0.54688-0.26562-0.29297-0.17969-0.53906-0.34375-0.73438-0.5-0.19922-0.15625-0.39062-0.33594-0.57812-0.53125-0.17969-0.19922-0.34375-0.41406-0.5-0.64062-0.15625-0.21875-0.30469-0.46094-0.4375-0.71875-0.13281-0.25-0.25781-0.52344-0.375-0.8125l0.51562-0.32812c0.51953 1.5625 1.3945 2.625 2.625 3.1875v-4h0.54688v4.6094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6406 2.6719-0.46875-0.3125c0.41406-0.49219 0.70312-1.0625 0.85938-1.7188l0.5 0.32812c-0.25 0.69531-0.54688 1.2656-0.89062 1.7031zm-0.60938 2.7031c-1.0117-0.6875-1.7461-1.3711-2.2031-2.0469-0.44922-0.67969-0.79297-1.4453-1.0312-2.2969l0.54688-0.34375c0.22656 1.0625 0.59375 1.9141 1.0938 2.5625 0.50781 0.65625 1.1719 1.2227 1.9844 1.7031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4375 5.5312v-2.125c-1.4297 0-2.3516-0.54688-2.7656-1.6406l0.48438-0.46875c0.14453 0.53125 0.38281 0.92188 0.71875 1.1719 0.34375 0.25 0.86328 0.37891 1.5625 0.39062v-2.3438h0.54688v2.3438h0.79688c-0.09375-0.51172-0.15234-1.1016-0.17188-1.7656l0.60938-0.25c-0.023438 0.16406-0.03125 0.35156-0.03125 0.5625 0 0.47656 0.066406 1.0195 0.20312 1.625 0.13281 0.60156 0.29688 1.0391 0.48438 1.3125l-0.45312 0.39062c-0.21875-0.375-0.39062-0.82031-0.51562-1.3281h-0.92188v2.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.14062 4.5938v-0.5h0.21875v-2.8594h0.5v2.8594h0.89062v-2.6719h0.5v2.6719h0.78125v-2.75h0.5v3.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.1094 5.3281-2.6875-2c-0.25 0.25781-0.65234 0.59375-1.2031 1l-0.40625-0.4375c0.92578-0.59375 1.7734-1.4023 2.5469-2.4219l0.40625 0.375c-0.30469 0.38281-0.62109 0.74219-0.95312 1.0781l2.0156 1.5156v-3.7656h0.54688v4.2969z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0938 3.25-0.20312-0.48438c0.50781-0.11719 0.92969-0.28906 1.2656-0.51562l0.17188 0.5c-0.44922 0.22656-0.85938 0.39453-1.2344 0.5zm1.1094 1.2656c-1.6562-0.0625-2.8203-0.87109-3.4844-2.4219l0.45312-0.35938c0.26953 0.73828 0.65625 1.2969 1.1562 1.6719 0.50781 0.38281 1.0938 0.57812 1.75 0.57812h0.21875zm-1.4062-2.3125-0.1875-0.5c0.53906-0.14844 0.96094-0.33594 1.2656-0.5625l0.1875 0.48438c-0.46875 0.30078-0.89062 0.49219-1.2656 0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5156 5.0938-0.4375-0.39062c0.58203-0.5625 1.0977-1.3711 1.5469-2.4219h-2.9062v-0.53125h5v0.53125h-1.8281l0.23438 0.25c-0.46094 1.0938-0.99609 1.9453-1.6094 2.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8594 5h3.1875v0.4375h-3.1875zm2.9219-2.2812c-0.085938-0.054688-0.24219-0.089844-0.46875-0.10938l-0.28125-0.015625c-0.13672 0-0.375 0.13281-0.71875 0.40625-0.34375 0.26953-0.64844 0.64062-0.90625 1.1094-0.085938-0.14844-0.21484-0.26562-0.39062-0.35938 0.375-0.58594 0.82812-1.0586 1.3594-1.4219-0.59375-0.33594-1.0742-0.78125-1.4375-1.3438 0.13281-0.074219 0.25781-0.1875 0.375-0.34375 0.22656 0.41406 0.53906 0.77344 0.9375 1.0781 0.40625 0.30078 0.9375 0.44531 1.5938 0.4375zm-5.1406 2.2812h1.4688v-3.4688h0.46875v3.9062h-1.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.2188 5.6094v-0.95312h-1.3594v-0.45312h3.1875v0.45312h-1.3594v0.95312zm-0.98438-1.9219c-0.09375-0.63672-0.14062-1.6367-0.14062-3h2.5938v2.625h-0.46875v-2.1406h-0.53125v2.0156h-0.46875v-2.0156h-0.65625c-0.011719 1.0703 0.035156 1.9102 0.14062 2.5156zm-2.5938 0.53125h1.4844v-3.0781h0.46875v3.5156h-1.9531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.40625 5.4375v-0.45312h2.5469v-0.73438h-2.2188v-0.46875h4.8281v0.46875h-2.1406v0.73438h2.4375v0.45312zm4.6094-2.2969h-3.7656v-2.375h3.7656zm-0.48438-1.9219h-2.8125v1.4688h2.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4688 4.9531v-3.8438h2.8438v3.7812h-0.48438v-3.2812h-0.70312v3.0938h-0.46875v-3.0938h-0.70312v3.3438zm-1.1562 0.70312v-5.3125h0.46875v5.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9062 4.0781-0.0625-0.51562c0.19531-0.0625 0.29688-0.26172 0.29688-0.59375 0-0.14844-0.03125-0.27734-0.09375-0.39062-0.0625-0.10547-0.14844-0.15625-0.25-0.15625-0.0625 0-0.13281 0.03125-0.20312 0.09375-0.0625 0.070313-0.16406 0.25-0.29688 0.53125-0.19922 0.40625-0.37109 0.66406-0.51562 0.78125-0.14844 0.125-0.29297 0.1875-0.4375 0.1875-0.30469 0-0.55469-0.16406-0.76562-0.48438-0.20703-0.3125-0.3125-0.79688-0.3125-1.4531 0-0.58594 0.10547-1.0469 0.3125-1.3906 0.21094-0.33594 0.50391-0.5 0.89062-0.5 0.19531 0 0.42578 0.046875 0.6875 0.14062l-0.10938 0.46875c-0.21094-0.0625-0.39844-0.09375-0.5625-0.09375-0.21875 0-0.38281 0.10156-0.48438 0.3125-0.10156 0.20703-0.15625 0.5625-0.15625 1.0625 0 0.46875 0.046875 0.82031 0.14062 1.0625 0.09375 0.23828 0.21094 0.35938 0.35938 0.35938 0.070312 0 0.14453-0.039062 0.21875-0.10938 0.082031-0.074219 0.19531-0.25781 0.34375-0.54688 0.19531-0.39844 0.35938-0.65234 0.48438-0.76562 0.13281-0.10547 0.26953-0.15625 0.40625-0.15625 0.22656 0 0.4375 0.097656 0.625 0.29688 0.19531 0.19531 0.29688 0.44531 0.29688 0.75 0 0.61328-0.27344 0.98438-0.8125 1.1094zm-3.3281-1.125v-0.42188h0.42188v0.42188zm0-0.78125v-0.4375h0.42188v0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.625 1.3438c-0.71094 0.57031-1.1992 0.85938-1.4688 0.85938-0.36719 0-0.65234-0.15625-0.85938-0.46875-0.19922-0.30469-0.29688-0.74609-0.29688-1.3281v-0.17188h0.57812v0.15625c0 0.875 0.19141 1.3125 0.57812 1.3125 0.25 0 0.73828-0.32422 1.4688-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.625v-0.015625c0-0.24219 0.046875-0.41406 0.14062-0.51562-0.44531-0.09375-0.78906-0.3125-1.0312-0.65625-0.25-0.34375-0.375-0.78125-0.375-1.3125 0-0.13281 0.015625-0.32812 0.046875-0.57812l0.51562 0.10938c-0.03125 0.17969-0.046875 0.33984-0.046875 0.48438 0 0.98828 0.46484 1.4844 1.3906 1.4844 0.22656 0 0.49219-0.046875 0.79688-0.14062v0.5625c-0.1875 0.039063-0.35938 0.066406-0.51562 0.078125-0.23047 0.03125-0.34375 0.1875-0.34375 0.46875v0.03125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.25 1.8281c-0.042969-0.14844-0.0625-0.25781-0.0625-0.32812 0-0.3125 0.085938-0.57422 0.26562-0.78125 0.1875-0.21094 0.45703-0.3125 0.8125-0.3125 0.28906 0 0.53906 0.09375 0.75 0.28125 0.21875 0.19531 0.32812 0.41406 0.32812 0.65625 0 0.26953-0.15625 0.51562-0.46875 0.73438-0.3125 0.22656-0.69922 0.34375-1.1562 0.34375-0.54297 0-0.96484-0.21484-1.2656-0.64062-0.30469-0.42969-0.45312-1.0234-0.45312-1.7812h0.57812c0 0.51953 0.050781 0.92188 0.15625 1.2031 0.10156 0.28125 0.27344 0.48828 0.51562 0.625zm0.5625 0.078125c0.23828 0 0.45703-0.058594 0.65625-0.17188 0.19531-0.11719 0.29688-0.24609 0.29688-0.39062 0-0.125-0.046875-0.23047-0.14062-0.3125-0.09375-0.074219-0.21484-0.10938-0.35938-0.10938-0.15625 0-0.28125 0.050781-0.375 0.15625-0.09375 0.10156-0.14062 0.23438-0.14062 0.39062 0 0.13281 0.019531 0.28125 0.0625 0.4375zm2.3125-0.4375v-0.51562h0.51562v0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.875v-0.015625c0-0.28125 0.0625-0.5 0.1875-0.65625 0.125-0.14844 0.3125-0.25 0.5625-0.3125-0.10547-0.054687-0.19922-0.15234-0.28125-0.29688-0.074219-0.13672-0.10938-0.28125-0.10938-0.4375 0-0.21875 0.070313-0.40625 0.21875-0.5625 0.14453-0.14844 0.34375-0.21875 0.59375-0.21875 0.26953 0 0.51562 0.10156 0.73438 0.3125 0.22656 0.21875 0.39844 0.54688 0.51562 0.98438l0.25-0.03125v0.5l-1.0469 0.14062c-0.36719 0.039062-0.58594 0.066406-0.65625 0.078125-0.074219 0.019531-0.14062 0.050781-0.20312 0.09375-0.0625 0.039063-0.10938 0.09375-0.14062 0.15625s-0.046875 0.13281-0.046875 0.21875v0.046875zm2.0156-1.1562c-0.15625-0.52344-0.43359-0.78125-0.82812-0.78125-0.074219 0-0.13672 0.023438-0.1875 0.078125-0.054688 0.0625-0.078125 0.13281-0.078125 0.21875 0 0.11328 0.050781 0.23438 0.15625 0.35938 0.10156 0.125 0.21094 0.1875 0.32812 0.1875 0.019531 0 0.22266-0.023438 0.60938-0.0625zm1.3281 0.32812v-0.42188h0.42188v0.42188zm0-0.78125v-0.4375h0.42188v0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1562 1.1562c-0.375 0-0.66406-0.10156-0.85938-0.29688-0.19922-0.19922-0.29688-0.48438-0.29688-0.85938h0.57812v0.21875c0 0.28906 0.19531 0.4375 0.59375 0.4375h3.125v0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.625 1.875c-0.03125-0.10547-0.046875-0.20312-0.046875-0.29688 0-0.3125 0.097656-0.58984 0.29688-0.82812 0.19531-0.24219 0.47656-0.35938 0.84375-0.35938 0.32031 0 0.59375 0.09375 0.8125 0.28125 0.21875 0.19531 0.32812 0.42578 0.32812 0.6875 0 0.28125-0.16797 0.53125-0.5 0.75-0.33594 0.22656-0.75781 0.34375-1.2656 0.34375-0.39844 0-0.77734-0.11719-1.1406-0.34375-0.375-0.23047-0.67188-0.54297-0.89062-0.9375-0.21875-0.39844-0.32812-0.8125-0.32812-1.25 0-0.13281 0.015625-0.32031 0.046875-0.5625l0.57812 0.09375c-0.03125 0.17969-0.046875 0.33984-0.046875 0.48438 0 0.46875 0.13281 0.87891 0.39062 1.2344 0.25 0.36328 0.55469 0.59766 0.92188 0.70312zm0.57812 0.0625c0.26953-0.011719 0.51562-0.078125 0.73438-0.20312 0.22656-0.11719 0.34375-0.24219 0.34375-0.375 0-0.11719-0.058594-0.22656-0.17188-0.32812-0.10547-0.09375-0.23438-0.14062-0.39062-0.14062s-0.29297 0.0625-0.40625 0.1875c-0.10547 0.125-0.15625 0.28125-0.15625 0.46875 0 0.15625 0.015625 0.28516 0.046875 0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.6406v-0.1875c0-0.35547 0.09375-0.60938 0.28125-0.76562 0.1875-0.14844 0.47656-0.21875 0.875-0.21875h3.1406v0.51562h-3.125c-0.39844 0-0.59375 0.14453-0.59375 0.4375v0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.96875 0.98438c1.0938 0.73828 1.6406 1.3672 1.6406 1.8906 0 0.33203-0.11719 0.60938-0.34375 0.82812-0.23047 0.21875-0.52344 0.32812-0.875 0.32812-0.42969 0-0.76562-0.19531-1.0156-0.57812-0.25-0.375-0.375-0.89062-0.375-1.5469v-1.9062h0.57812v0.46875h3.5312v0.51562zm-0.39062 0.26562v0.65625c0 0.5 0.066406 0.89062 0.20312 1.1719 0.14453 0.28906 0.34375 0.4375 0.59375 0.4375 0.1875 0 0.34375-0.0625 0.46875-0.1875 0.13281-0.125 0.20312-0.27734 0.20312-0.45312 0-0.38672-0.49219-0.92969-1.4688-1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.48438 2.8125c-0.25-0.60547-0.41406-1.4336-0.48438-2.4844h0.57812v0.3125c0.007813 0.16406 0.019531 0.26953 0.03125 0.3125 0.082031-0.17969 0.20312-0.32031 0.35938-0.42188 0.15625-0.10547 0.33203-0.15625 0.53125-0.15625 0.28125 0 0.51953 0.097656 0.71875 0.29688 0.20703 0.20703 0.3125 0.48438 0.3125 0.82812 0 0.66406-0.30469 1.0547-0.90625 1.1719l-0.0625-0.53125c0.26953-0.054687 0.40625-0.26562 0.40625-0.64062 0-0.19922-0.046875-0.35547-0.14062-0.46875-0.09375-0.10547-0.21875-0.15625-0.375-0.15625-0.30469 0-0.55469 0.20703-0.75 0.625 0.070313 0.46875 0.19141 0.90625 0.35938 1.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.4062v-0.1875c0-0.38672 0.11328-0.65234 0.34375-0.79688-0.23047-0.38672-0.34375-0.89062-0.34375-1.5156v-1.9062h0.57812v0.46875h3.5312v0.51562h-3.1406c1.0938 0.73828 1.6406 1.3672 1.6406 1.8906 0 0.33203-0.11719 0.60938-0.34375 0.82812-0.23047 0.21875-0.52344 0.32812-0.875 0.32812-0.24219 0-0.45312-0.0625-0.64062-0.1875-0.11719 0.0625-0.17188 0.17578-0.17188 0.34375v0.21875zm0.57812-3.1562v0.65625c0 0.5 0.066406 0.89062 0.20312 1.1719 0.14453 0.28906 0.34375 0.4375 0.59375 0.4375 0.1875 0 0.34375-0.0625 0.46875-0.1875 0.13281-0.125 0.20312-0.27734 0.20312-0.45312 0-0.38672-0.49219-0.92969-1.4688-1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.59375 3.1406c-0.17969-0.54297-0.32422-1.1055-0.4375-1.6875-0.10547-0.58594-0.15625-1.0703-0.15625-1.4531h0.57812c0 0.25781 0.023437 0.59766 0.078125 1.0156 0.10156-0.1875 0.25-0.33984 0.4375-0.45312 0.19531-0.10547 0.39844-0.15625 0.60938-0.15625 0.375 0 0.67578 0.11719 0.90625 0.35938 0.22656 0.23828 0.34375 0.55078 0.34375 0.9375 0 0.73828-0.32031 1.1719-0.95312 1.2969l-0.078125-0.51562c0.30078-0.074219 0.45312-0.33594 0.45312-0.78125 0-0.23047-0.0625-0.42188-0.1875-0.57812-0.11719-0.14844-0.27734-0.21875-0.48438-0.21875-0.19922 0-0.38672 0.0625-0.5625 0.1875-0.16797 0.13281-0.29297 0.3125-0.375 0.53125 0.082031 0.41406 0.21875 0.92188 0.40625 1.5156zm3.1875-1.3125v-0.51562h0.51562v0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-1.2344h8.4062v-0.95312h-8.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.3281-6.5h6.7344v0.015625l-6.8125 4.3438v0.92188h8.4062v-0.92188h-6.7969l6.7969-4.3438v-0.9375h-8.4062v0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-3.1094v1.8906h8.4062v-1.875c0-2.8125-1.25-4.5-4.2031-4.5s-4.2031 1.6875-4.2031 4.4844zm7.625 0.95312h-6.8438v-0.875c0-2.3281 0.92188-3.5625 3.4219-3.5625 2.5156 0 3.4219 1.2344 3.4219 3.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.3594-6.1406 1.9688 0.6875 5.0781 1.8125-5.0156 1.7812c-0.6875 0.23438-2.0312 0.70312-2.0312 0.70312h-0.046875v1.0312h0.046875s1.3438-0.5 2.0312-0.76562l6.3281-2.3281v-0.84375l-6.3906-2.3594-1.9688-0.73438h-0.046875v1.0156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.3281-6.6562h5.1094c2.0625 0 2.5625 1.25 2.5625 2.2812 0 1.1406-0.5 2.3438-2.5625 2.3438h-5.1875v0.95312h5.2656c2.4219 0 3.3125-1.6406 3.3125-3.2969 0-1.5469-0.89062-3.25-3.3125-3.25h-5.2656v0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-4.3125v0.84375l6.4219 2.5469 1.9531 0.78125h0.03125v-1.0156l-0.046875-0.015625s-1.2969-0.5-1.9375-0.73438l-0.15625-0.0625v-3.8281l0.0625-0.015625c0.6875-0.26562 2.0469-0.78125 2.0469-0.78125h0.03125v-1.0312h-0.03125s-1.3594 0.54688-2.0469 0.8125zm1.2188 0.42188 4.2812-1.625v3.2656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.78125-5.7969v3.6406h-7.625v0.9375h8.4062v-4.625h-0.78125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.78125-6.3594v4.2031h-3.1719v-3.875h-0.78125v3.875h-2.8906v-4.1875h-0.78125v5.125h8.4062v-5.1875h-0.78125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.40625-0.79688c0.21875-0.35938 0.51562-1.1406 0.51562-2.1719 0-1.9375-1.0156-2.9219-2.3281-2.9219-1.125 0-1.8438 0.59375-2.3281 1.8594l-0.375 1.0625c-0.28125 0.76562-0.6875 1.1406-1.4062 1.1406-0.75 0-1.3594-0.60938-1.3594-1.8125 0-0.85938 0.29688-1.5156 0.53125-1.875v-0.03125h-0.95312c-0.1875 0.32812-0.39062 1-0.39062 1.9531 0 1.7031 0.96875 2.7344 2.2656 2.7344 0.95312 0 1.7344-0.5625 2.1719-1.7344l0.375-1.0469c0.34375-0.90625 0.79688-1.2969 1.5469-1.2969 0.71875 0 1.4375 0.53125 1.4375 1.9219 0 1.0156-0.375 1.8125-0.67188 2.2031v0.015625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.25v-0.90625l-8.3594-4.375h-0.046875v0.90625l8.375 4.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-3.9062v2.6875h8.4062v-0.9375h-3.5v-1.75c0-1.875-0.875-2.8906-2.4531-2.8906s-2.4531 1.0156-2.4531 2.8906zm4.1406 1.75h-3.375v-1.7031c0-1.2969 0.48438-1.9531 1.6875-1.9531s1.6875 0.65625 1.6875 1.9531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-7.625-4.4844c0-1.0938 0.39062-1.7812 0.70312-2.0625v-0.046875h-1c-0.26562 0.35938-0.5625 1.0781-0.5625 2.1406 0 2.0781 1.5469 3.8125 4.2812 3.8125s4.2812-1.7344 4.2812-3.8125c0-1.0625-0.29688-1.7812-0.5625-2.1406h-0.98438v0.046875c0.3125 0.28125 0.70312 0.96875 0.70312 2.0625 0 1.5469-1.125 2.8438-3.4375 2.8438-2.2969 0-3.4219-1.2969-3.4219-2.8438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-8.5312v0.95312l4.7344 2.6875-4.7344 2.7188v0.9375h8.4062v-0.95312h-6.7969v-0.015625l4.6406-2.6406v-0.078125l-4.6406-2.6406v-0.015625h6.7969v-0.95312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-5.875v5.7812h0.78125v-2.4219h7.625v-0.9375h-7.625v-2.4219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.3281-5.2031c-0.125-0.5625-0.57812-1.5469-1.9531-1.5469-1.5312 0-2.125 1.1094-2.125 2.6875v2.8438h8.4062v-2.7969c0-1.6719-0.625-2.8906-2.25-2.8906-1.3438 0-1.9531 0.82812-2.0625 1.7031zm-3.3594 1.25c0-1.2031 0.46875-1.875 1.4844-1.875 0.9375 0 1.5312 0.5625 1.5312 1.875v1.7969h-3.0156zm6.9688 1.7969h-3.2344v-1.7656c0-1.4219 0.51562-2.0469 1.625-2.0469 1.0156 0 1.6094 0.57812 1.6094 2.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.32812h3.3125v1l-2.2656 0.59375 2.2656 0.59375v1.0156h-3.3125v-0.625h2.6094l-2.6094-0.65625v-0.64062l2.6094-0.65625h-2.6094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.34375h3.3125v2.4531h-0.5625v-1.7969h-0.73438v1.6719h-0.5625v-1.6719h-0.89062v1.8594h-0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3125 0.32812v1.2344c0 0.26953-0.023438 0.47656-0.0625 0.625-0.0625 0.19531-0.16797 0.36328-0.3125 0.5-0.14844 0.13281-0.32422 0.23828-0.53125 0.3125-0.21094 0.070312-0.46875 0.10938-0.78125 0.10938-0.27344 0-0.50781-0.03125-0.70312-0.09375-0.24219-0.085937-0.4375-0.20312-0.59375-0.35938-0.10547-0.11719-0.19531-0.27344-0.26562-0.46875-0.042969-0.14844-0.0625-0.34375-0.0625-0.59375v-1.2656zm-0.5625 0.67188h-2.1875v0.5c0 0.1875 0.007812 0.32031 0.03125 0.40625 0.019531 0.10156 0.0625 0.19141 0.125 0.26562 0.070312 0.070313 0.17969 0.12891 0.32812 0.17188 0.14453 0.050781 0.34766 0.078125 0.60938 0.078125 0.25 0 0.44141-0.027344 0.57812-0.078125 0.14453-0.042969 0.25391-0.10547 0.32812-0.1875 0.070312-0.074219 0.125-0.17188 0.15625-0.29688 0.019531-0.09375 0.03125-0.28125 0.03125-0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.3125h3.3125v0.67188h-3.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.3281v-0.73438l0.75-0.28125v-1.3281l-0.75-0.28125v-0.70312l3.3125 1.2969v0.70312zm1.3125-1.2344 1.2188-0.45312-1.2188-0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.0625 0 3.4219 0.8125v0.48438l-3.4219-0.84375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.0781h2.75v-0.98438h0.5625v2.6406h-0.5625v-0.98438h-2.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.34375h3.3125v0.65625l-2.2188 1.3438h2.2188v0.625h-3.3125v-0.67188l2.1562-1.3281h-2.1562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.34375h3.3125v0.65625h-1.3125v1.3125h1.3125v0.67188h-3.3125v-0.67188h1.4531v-1.3125h-1.4531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6406 0.20312c0.33203 0 0.61328 0.050781 0.84375 0.15625 0.16406 0.070313 0.31641 0.17188 0.45312 0.29688 0.13281 0.13281 0.23438 0.28125 0.29688 0.4375 0.082031 0.19531 0.125 0.42969 0.125 0.70312 0 0.48828-0.15234 0.87891-0.45312 1.1719-0.30469 0.28906-0.71875 0.4375-1.25 0.4375-0.54297 0-0.96484-0.14844-1.2656-0.4375-0.30469-0.28125-0.45312-0.66797-0.45312-1.1562 0-0.49219 0.14844-0.88281 0.45312-1.1719 0.30078-0.29297 0.71875-0.4375 1.25-0.4375zm0.015625 0.6875c-0.375 0-0.66406 0.082031-0.85938 0.25-0.1875 0.17578-0.28125 0.39844-0.28125 0.67188 0 0.25781 0.09375 0.47266 0.28125 0.64062 0.19531 0.17578 0.48828 0.26562 0.875 0.26562 0.375 0 0.65625-0.085938 0.84375-0.25 0.1875-0.16797 0.28125-0.38672 0.28125-0.65625 0-0.28125-0.09375-0.50781-0.28125-0.67188-0.1875-0.16797-0.47656-0.25-0.85938-0.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0781 0.17188 0.0625 0.64062c-0.21875 0.039062-0.38281 0.11719-0.48438 0.23438-0.10547 0.125-0.15625 0.28906-0.15625 0.5 0 0.20703 0.046875 0.36328 0.14062 0.46875 0.09375 0.11328 0.20312 0.17188 0.32812 0.17188 0.070312 0 0.13281-0.027344 0.1875-0.078125 0.0625-0.042969 0.11328-0.12109 0.15625-0.23438 0.019531-0.074219 0.066406-0.25 0.14062-0.53125 0.082031-0.35547 0.19141-0.60547 0.32812-0.75 0.17578-0.21094 0.39453-0.3125 0.65625-0.3125 0.17578 0 0.33594 0.046875 0.48438 0.14062 0.14453 0.10156 0.25391 0.24219 0.32812 0.42188 0.070312 0.17578 0.10938 0.39453 0.10938 0.65625 0 0.41406-0.089844 0.72656-0.26562 0.9375-0.17969 0.20703-0.42188 0.31641-0.73438 0.32812l-0.03125-0.67188c0.17578-0.03125 0.30078-0.09375 0.375-0.1875 0.070313-0.09375 0.10938-0.23438 0.10938-0.42188s-0.042969-0.33984-0.125-0.45312c-0.042969-0.074219-0.10938-0.10938-0.20312-0.10938-0.074219 0-0.14062 0.035156-0.20312 0.10938-0.0625 0.082031-0.13672 0.28516-0.21875 0.60938-0.074219 0.32031-0.15234 0.5625-0.23438 0.71875-0.085937 0.15625-0.19922 0.27344-0.34375 0.35938-0.13672 0.09375-0.30859 0.14062-0.51562 0.14062-0.1875 0-0.36719-0.054687-0.53125-0.15625-0.16797-0.10547-0.29297-0.25781-0.375-0.45312-0.082031-0.1875-0.125-0.42969-0.125-0.71875 0-0.41797 0.09375-0.74219 0.28125-0.96875 0.19531-0.21875 0.48438-0.35156 0.85938-0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.046875h0.60938l2.1406 1.7344v-1.5312h0.5625v2.4219h-0.51562l-2.2344-1.8125v1.875h-0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.35938h3.2812v0.65625h-2.7188v1.6719h-0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3125 0.32812v0.67188h-1.7969c-0.28125 0-0.46484 0.007812-0.54688 0.03125-0.13672 0.019531-0.24609 0.082031-0.32812 0.1875-0.085937 0.11328-0.125 0.26562-0.125 0.45312s0.035156 0.32812 0.10938 0.42188c0.082031 0.10156 0.17969 0.16016 0.29688 0.17188 0.11328 0.019531 0.30078 0.03125 0.5625 0.03125h1.8281v0.67188h-1.7344c-0.40625 0-0.69531-0.023438-0.85938-0.0625-0.15625-0.03125-0.29297-0.09375-0.40625-0.1875-0.11719-0.09375-0.21094-0.22656-0.28125-0.39062-0.0625-0.16797-0.09375-0.38281-0.09375-0.64062 0-0.3125 0.039062-0.55469 0.10938-0.71875 0.070313-0.15625 0.16406-0.28906 0.28125-0.39062 0.125-0.09375 0.25-0.15625 0.375-0.1875 0.1875-0.042969 0.46875-0.0625 0.84375-0.0625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.34375h3.3125v1.4062c0 0.35156-0.03125 0.60938-0.09375 0.76562s-0.17188 0.28125-0.32812 0.375c-0.14844 0.10156-0.32031 0.15625-0.51562 0.15625-0.24219 0-0.44531-0.074219-0.60938-0.21875-0.15625-0.14844-0.25781-0.36719-0.29688-0.65625-0.09375 0.14453-0.19531 0.26562-0.29688 0.35938-0.09375 0.09375-0.27344 0.21875-0.53125 0.375l-0.64062 0.40625v-0.79688l0.71875-0.48438c0.25781-0.16797 0.42188-0.28906 0.48438-0.35938 0.070313-0.0625 0.11719-0.13281 0.14062-0.20312 0.019531-0.0625 0.03125-0.17188 0.03125-0.32812v-0.14062h-1.375zm1.9062 0.65625v0.5c0 0.32031 0.00781 0.51953 0.03125 0.59375 0.03125 0.082031 0.078125 0.14453 0.14062 0.1875 0.070313 0.050781 0.16016 0.078125 0.26562 0.078125 0.10156 0 0.19141-0.03125 0.26562-0.09375 0.070313-0.0625 0.11328-0.14844 0.125-0.25 0.007813-0.054687 0.015625-0.21484 0.015625-0.48438v-0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2188 1.875h0.5625v1.4375h-1.3281c-0.13672-0.13672-0.25781-0.33984-0.35938-0.60938-0.10156-0.26172-0.15625-0.52734-0.15625-0.79688 0-0.35547 0.070312-0.66406 0.21875-0.92188 0.14453-0.25 0.35156-0.44531 0.625-0.57812 0.26953-0.125 0.56641-0.1875 0.89062-0.1875 0.34375 0 0.64453 0.070312 0.90625 0.21875 0.26953 0.14453 0.47656 0.35938 0.625 0.64062 0.10156 0.20703 0.15625 0.46875 0.15625 0.78125 0 0.41406-0.089844 0.73828-0.26562 0.96875-0.16797 0.22656-0.40234 0.37891-0.70312 0.45312l-0.125-0.67188c0.16406-0.042969 0.29688-0.13281 0.39062-0.26562 0.09375-0.125 0.14062-0.28906 0.14062-0.48438 0-0.29297-0.09375-0.52734-0.28125-0.70312-0.1875-0.16797-0.46484-0.25-0.82812-0.25-0.38672 0-0.67969 0.085938-0.875 0.26562-0.19922 0.17578-0.29688 0.40625-0.29688 0.6875 0 0.13281 0.023437 0.26953 0.078125 0.40625 0.0625 0.14453 0.12891 0.26953 0.20312 0.375h0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6406 0.20312c0.33203 0 0.61328 0.050781 0.84375 0.15625 0.16406 0.070313 0.31641 0.17188 0.45312 0.29688 0.13281 0.13281 0.23438 0.28125 0.29688 0.4375 0.082031 0.19531 0.125 0.42969 0.125 0.70312 0 0.48828-0.15234 0.87891-0.45312 1.1719-0.30469 0.28906-0.71875 0.4375-1.25 0.4375-0.54297 0-0.96484-0.14844-1.2656-0.4375-0.30469-0.28125-0.45312-0.66797-0.45312-1.1562 0-0.49219 0.14844-0.88281 0.45312-1.1719 0.30078-0.29297 0.71875-0.4375 1.25-0.4375zm0.015625 0.6875c-0.375 0-0.66406 0.082031-0.85938 0.25-0.1875 0.17578-0.28125 0.39844-0.28125 0.67188 0 0.25781 0.09375 0.47266 0.28125 0.64062 0.19531 0.17578 0.48828 0.26562 0.875 0.26562 0.375 0 0.65625-0.085938 0.84375-0.25 0.1875-0.16797 0.28125-0.38672 0.28125-0.65625 0-0.28125-0.09375-0.50781-0.28125-0.67188-0.1875-0.16797-0.47656-0.25-0.85938-0.25zm1.8438 0.125h0.53125v0.54688h-0.53125zm0 0.96875h0.53125v0.54688h-0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.34375h3.3125v1.0625c0 0.40625-0.015625 0.67188-0.046875 0.79688-0.054687 0.1875-0.16406 0.34375-0.32812 0.46875-0.16797 0.13281-0.38281 0.20312-0.64062 0.20312-0.21094 0-0.38281-0.039062-0.51562-0.10938-0.13672-0.074219-0.24609-0.16797-0.32812-0.28125-0.085937-0.11719-0.13672-0.23047-0.15625-0.34375-0.03125-0.16797-0.046875-0.40234-0.046875-0.70312v-0.4375h-1.25zm2.75 0.65625h-0.9375v0.375c0 0.25781 0.015625 0.42969 0.046875 0.51562 0.039063 0.09375 0.097656 0.16406 0.17188 0.21875 0.070312 0.050781 0.15625 0.078125 0.25 0.078125 0.125 0 0.22266-0.039062 0.29688-0.10938 0.082031-0.074219 0.13281-0.16406 0.15625-0.26562 0.007813-0.085938 0.015625-0.24609 0.015625-0.48438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3125 0.34375v1.3125c0 0.26953-0.011719 0.46875-0.03125 0.59375-0.023438 0.125-0.070312 0.23828-0.14062 0.34375-0.074219 0.10156-0.16797 0.1875-0.28125 0.25-0.11719 0.070312-0.24219 0.10938-0.375 0.10938-0.15625 0-0.30469-0.042969-0.4375-0.125-0.125-0.085937-0.21875-0.19922-0.28125-0.34375-0.0625 0.19531-0.16797 0.34766-0.3125 0.45312-0.13672 0.11328-0.30469 0.17188-0.5 0.17188-0.14844 0-0.29297-0.039063-0.4375-0.10938-0.13672-0.0625-0.25-0.15625-0.34375-0.28125-0.085938-0.125-0.13672-0.27734-0.15625-0.45312-0.011719-0.10547-0.015625-0.37109-0.015625-0.79688v-1.125zm-0.54688 0.65625h-0.76562v0.9375c0.019531 0.11328 0.0625 0.20312 0.125 0.26562s0.14453 0.09375 0.25 0.09375c0.10156 0 0.1875-0.03125 0.25-0.09375 0.070312-0.054687 0.11328-0.13281 0.125-0.23438 0.007812-0.074219 0.015625-0.26562 0.015625-0.57812zm-1.3281 0h-0.875v0.625c0 0.23828 0.003906 0.39062 0.015625 0.45312 0.019531 0.10156 0.0625 0.1875 0.125 0.25 0.070313 0.0625 0.16406 0.09375 0.28125 0.09375 0.10156 0 0.1875-0.027344 0.25-0.078125 0.070313-0.042969 0.125-0.10938 0.15625-0.20312s0.046875-0.29297 0.046875-0.59375z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m283.61 567.08v-0.14844h-283.31v-566.63h283.16v566.78h0.14843v-0.14844 0.14844h0.15235v-567.08h-283.77v567.23h283.77v-0.15234",
    fill: "#eb262a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.074 159.66v1.5781l1.2852-0.48047c0.39062-0.14844 0.71094-0.25781 0.96875-0.33203-0.30469-0.0664-0.60156-0.15234-0.89453-0.25781zm-1.9023-1.3359 4.6328 1.7773v0.67578l-4.6328 1.8867v-0.69531l1.4023-0.53906v-1.9531l-1.4023-0.5039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.758 163.77v1.3164c0 0.28125 0.0312 0.5 0.0898 0.65625s0.15234 0.27735 0.27734 0.35938c0.12891 0.082 0.26563 0.12109 0.41407 0.12109 0.22265 0 0.40234-0.0781 0.54296-0.23828 0.14063-0.15625 0.21094-0.40625 0.21094-0.75v-1.4648zm-2.5898-0.61719h4.6367v2.0547c0 0.41406-0.0391 0.73047-0.125 0.9414-0.082 0.21485-0.23047 0.38672-0.44141 0.51563-0.20703 0.1289-0.4414 0.1914-0.69531 0.1914-0.32812 0-0.60547-0.10546-0.83203-0.3164-0.22656-0.21485-0.36719-0.54297-0.42969-0.98438-0.082 0.16016-0.15625 0.28516-0.23047 0.36719-0.16406 0.17969-0.37109 0.34766-0.61718 0.50781l-1.2656 0.80078v-0.76562l0.96875-0.61328c0.27735-0.17969 0.48828-0.32422 0.63672-0.44141 0.14844-0.11328 0.25391-0.21875 0.3125-0.30859 0.0586-0.0937 0.0977-0.1875 0.12109-0.28125 0.0156-0.0703 0.0234-0.1836 0.0234-0.33985v-0.71093h-2.0625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.172 169h4.0898v-1.5274h0.54297v3.668h-0.54297v-1.5273h-4.0898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.816 172.51h-0.64453v-0.64453h0.64453zm2.7148 0h-0.64843v-0.64453h0.64843z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.961 265.94h39.324v-107.62h-39.324z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.961 158.32v0.14062h39.18v107.34h-39.039v-107.48h-0.14063v0.14062-0.14062h-0.14062v107.76h39.605v-107.9h-39.605v0.14063",
    fill: "#231f20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m70.469 385.99v-0.125h-56.57v-104.63h56.445v104.76h0.125v-0.125 0.125h0.125v-105.01h-56.945v105.13h56.945v-0.125",
    fill: "#eb262a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m30.781 371.82h22.676v-76.535h-22.676z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.457 295.29v-0.125h-22.801v76.781h22.926v-76.781h-0.125v0.125h-0.125v76.406h-22.426v-76.281h22.551v-0.125h-0.125"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-373.84 -87.504)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 174.105,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 175.653,
    xlinkHref: "#glyph-0-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 178.869,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 180.41701,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 185.295,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 189.177,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 193.38901,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 196.935,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 200.817,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 204.033,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 205.58099,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 207.129,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 211.341,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 215.55299,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 217.101,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 220.983,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 222.53101,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 226.743,
    xlinkHref: "#glyph-0-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 230.955,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 234.83701,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 238.05299,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 239.601,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 241.149,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 242.69701,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 246.243,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 250.791,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 254.673,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 257.88901,
    xlinkHref: "#glyph-0-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 262.10101,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 265.983,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 267.53101,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 271.74301,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 275.625,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 277.173,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 282.05099,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 285.93301,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 289.815,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 293.69699,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 295.245,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 296.793,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 301.005,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 305.21701,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 306.76501,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 310.647,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 312.19501,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 316.40701,
    xlinkHref: "#glyph-0-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 320.61899,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 324.50101,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 327.71701,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 329.26501,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 330.81299,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 332.36099,
    xlinkHref: "#glyph-0-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 336.24301,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 339.45901,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 343.341,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 347.55301,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 351.435,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 352.983,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 357.86099,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 361.74301,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 365.289,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 366.83701,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 368.38501,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 369.93301,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 373.815,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 377.69699,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 381.24301,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 382.79099,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 387.00299,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 390.88501,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 392.43301,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 395.979,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 399.86099,
    xlinkHref: "#glyph-0-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 403.74301,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 406.95901,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 410.841,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 412.38901,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 413.93701,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 415.48499,
    xlinkHref: "#glyph-0-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 419.367,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 422.58301,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 426.465,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 430.677,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 434.55899,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 439.43701,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 443.319,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 446.86499,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 448.41299,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 449.961,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 451.509,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 455.05499,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 459.603,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 463.48499,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 467.367,
    xlinkHref: "#glyph-0-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 471.91501,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 475.13101,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 476.67899,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 480.561,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 484.10699,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 487.65302,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 491.535,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 493.08301,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 496.965,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 501.84299,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 505.72501,
    xlinkHref: "#glyph-0-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 509.93701,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 511.48499,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 515.69702,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 519.57898,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 523.79102,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 527.67297,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 529.22101,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 530.76898,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 532.31702,
    xlinkHref: "#glyph-0-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 536.19897,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 539.41498,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 543.297,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 546.84302,
    xlinkHref: "#glyph-0-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 550.38898,
    xlinkHref: "#glyph-0-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 552.26703,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 556.14899,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 560.03101,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 563.57703,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 565.125,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 566.67297,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 568.22101,
    xlinkHref: "#glyph-0-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 571.71301,
    xlinkHref: "#glyph-0-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 575.59497,
    xlinkHref: "#glyph-0-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.41299,
    y: 579.14099,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 177.09309,
    xlinkHref: "#glyph-0-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 180.6391,
    xlinkHref: "#glyph-0-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 184.5211,
    xlinkHref: "#glyph-0-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 188.40311,
    xlinkHref: "#glyph-0-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 192.6151,
    xlinkHref: "#glyph-0-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 196.4971,
    xlinkHref: "#glyph-0-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 200.04311,
    xlinkHref: "#glyph-0-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 204.59109,
    xlinkHref: "#glyph-0-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 209.4691,
    xlinkHref: "#glyph-0-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 213.3511,
    xlinkHref: "#glyph-0-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 217.5631,
    xlinkHref: "#glyph-0-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 221.1091,
    xlinkHref: "#glyph-0-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 222.6571,
    xlinkHref: "#glyph-0-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 226.53909,
    xlinkHref: "#glyph-0-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 231.0871,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 232.59906,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 234.14706,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 235.65923,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 239.87123,
    xlinkHref: "#glyph-0-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 245.75122,
    xlinkHref: "#glyph-0-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 249.63322,
    xlinkHref: "#glyph-0-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 253.51523,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 257.39722,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 261.27924,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 265.16122,
    xlinkHref: "#glyph-0-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 269.37323,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 273.25522,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 274.80322,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 278.68521,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 282.23123,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 283.74335,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 285.29132,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 286.8027,
    xlinkHref: "#glyph-0-41"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 292.68271,
    xlinkHref: "#glyph-0-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 298.56271,
    xlinkHref: "#glyph-0-43"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 304.44272,
    xlinkHref: "#glyph-0-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 310.32272,
    xlinkHref: "#glyph-0-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 316.20273,
    xlinkHref: "#glyph-0-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 322.0827,
    xlinkHref: "#glyph-0-46"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 327.96271,
    xlinkHref: "#glyph-0-47"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 333.84271,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 335.35443,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 336.90244,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 338.41458,
    xlinkHref: "#glyph-0-48"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 344.29459,
    xlinkHref: "#glyph-0-49"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 350.17459,
    xlinkHref: "#glyph-0-50"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 356.0546,
    xlinkHref: "#glyph-0-51"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 361.9346,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 363.44672,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 364.99472,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 366.50607,
    xlinkHref: "#glyph-0-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 370.38809,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 374.9361,
    xlinkHref: "#glyph-0-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 379.14807,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 383.36008,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 387.2421,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 390.78809,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 394.67007,
    xlinkHref: "#glyph-0-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 398.55209,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 401.7681,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 405.65009,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 409.19608,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 412.7421,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 414.25421,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 415.80219,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 417.1839,
    xlinkHref: "#glyph-0-52"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 421.44989,
    xlinkHref: "#glyph-0-53"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 423.90988,
    xlinkHref: "#glyph-0-54"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 426.52606,
    xlinkHref: "#glyph-0-55"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 429.16553,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 430.71353,
    xlinkHref: "#glyph-0-56"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 433.57568,
    xlinkHref: "#glyph-0-57"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 435.09369,
    xlinkHref: "#glyph-0-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 437.7937,
    xlinkHref: "#glyph-0-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 439.43118,
    xlinkHref: "#glyph-0-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 443.67337,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 445.22137,
    xlinkHref: "#glyph-0-61"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 448.27536,
    xlinkHref: "#glyph-0-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 449.91321,
    xlinkHref: "#glyph-0-62"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 454.31049,
    xlinkHref: "#glyph-0-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 459.33978,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 460.88779,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 462.39917,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 467.27716,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 471.15915,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 475.37115,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 478.91714,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 482.79916,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 486.01517,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 487.52649,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 489.07449,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 493.2865,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 497.49847,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 499.04648,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 502.9285,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 504.4765,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 508.68848,
    xlinkHref: "#glyph-0-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 512.90051,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 516.78247,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 521.51044,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 523.05841,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 524.57062,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 528.45258,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 532.33459,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 535.88062,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 540.42859,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 544.31061,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 548.19257,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 551.40857,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 554.62457,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 558.50659,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41068,
    y: 562.38861,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 318.65109,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 320.1991,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 324.4111,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 328.62311,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 330.17111,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 334.0531,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 335.6011,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 339.81311,
    xlinkHref: "#glyph-0-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 344.02509,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 347.9071,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 351.12311,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 355.0051,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 356.5531,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 358.1011,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 359.64911,
    xlinkHref: "#glyph-0-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 363.5311,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 367.41309,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 371.62509,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 375.50711,
    xlinkHref: "#glyph-0-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 379.3891,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 383.9371,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 385.48511,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 390.3631,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 394.24509,
    xlinkHref: "#glyph-0-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 398.45709,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 402.33911,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 403.88708,
    xlinkHref: "#glyph-0-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 405.76511,
    xlinkHref: "#glyph-0-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 409.3111,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 413.19312,
    xlinkHref: "#glyph-0-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 417.0751,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.40872,
    y: 418.62311,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.229,
    y: 519.90198,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.229,
    y: 535.409,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.229,
    y: 537.91101,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.229,
    y: 540.41302,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.229,
    y: 542.91498,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.229,
    y: 545.41699,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.229,
    y: 573.93799,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 487.51999,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 484.23203,
    xlinkHref: "#glyph-5-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 475.72403,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 467.61203,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 464.32404,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 457.16003,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 453.87207,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 445.76007,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 437.57593,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 429.91989,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 424.08801,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 417.20004,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 408.52408,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 400.44806,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 393.45206,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 387.60809,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 380.21613,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 373.07614,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 366.18814,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 356.56412,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 349.46024,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 343.88019,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 335.20294,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 327.12692,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 320.62296,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 313.73495,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 305.61075,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 297.49872,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 288.33054,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 283.03836,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 275.38235,
    xlinkHref: "#glyph-5-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 267.84634,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.36902,
    y: 262.01453,
    xlinkHref: "#glyph-5-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m82.477 394.45h0.15625v-254.11h7.3242v253.96h-7.4805v0.15235h0.15625-0.15625v0.15625h7.7891v-254.58h-7.9414v254.58h0.15235"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-373.84 -87.504)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 240.039,
    xlinkHref: "#glyph-6-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 243.88638,
    xlinkHref: "#glyph-6-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 246.96706,
    xlinkHref: "#glyph-6-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 250.30176,
    xlinkHref: "#glyph-6-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 251.58575,
    xlinkHref: "#glyph-6-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 254.92046,
    xlinkHref: "#glyph-6-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 259.36646,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 260.65274,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 261.93674,
    xlinkHref: "#glyph-6-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 264.41559,
    xlinkHref: "#glyph-6-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 267.75031,
    xlinkHref: "#glyph-6-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 271.59769,
    xlinkHref: "#glyph-6-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 274.93237,
    xlinkHref: "#glyph-6-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 278.26709,
    xlinkHref: "#glyph-6-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 281.60178,
    xlinkHref: "#glyph-6-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 285.19513,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 286.4769,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 287.76312,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 289.04712,
    xlinkHref: "#glyph-6-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 292.12781,
    xlinkHref: "#glyph-6-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 293.4118,
    xlinkHref: "#glyph-6-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 296.23383,
    xlinkHref: "#glyph-6-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 299.31448,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 300.59625,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 301.88251,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 303.1665,
    xlinkHref: "#glyph-6-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 305.64493,
    xlinkHref: "#glyph-6-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 308.97961,
    xlinkHref: "#glyph-6-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 310.26361,
    xlinkHref: "#glyph-6-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 313.08563,
    xlinkHref: "#glyph-6-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 315.90765,
    xlinkHref: "#glyph-6-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 318.98834,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 320.27005,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 321.55634,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 322.84033,
    xlinkHref: "#glyph-6-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 326.68771,
    xlinkHref: "#glyph-6-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 330.0224,
    xlinkHref: "#glyph-6-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 333.01523,
    xlinkHref: "#glyph-6-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 335.83725,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 337.11899,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 338.4053,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 339.6893,
    xlinkHref: "#glyph-6-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 343.53668,
    xlinkHref: "#glyph-6-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 344.82068,
    xlinkHref: "#glyph-6-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 347.90134,
    xlinkHref: "#glyph-6-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 351.23605,
    xlinkHref: "#glyph-6-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 354.57074,
    xlinkHref: "#glyph-6-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 357.65143,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 358.93311,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 360.21942,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 361.50342,
    xlinkHref: "#glyph-6-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 365.09677,
    xlinkHref: "#glyph-6-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 368.43146,
    xlinkHref: "#glyph-6-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 372.02481,
    xlinkHref: "#glyph-6-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 375.10547,
    xlinkHref: "#glyph-6-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 378.18616,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 379.4679,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 380.75415,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 382.03815,
    xlinkHref: "#glyph-6-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 385.88553,
    xlinkHref: "#glyph-6-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 388.96619,
    xlinkHref: "#glyph-6-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 391.78824,
    xlinkHref: "#glyph-6-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 394.8689,
    xlinkHref: "#glyph-6-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 398.46225,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 399.74399,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 401.0303,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 402.3143,
    xlinkHref: "#glyph-6-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 405.64899,
    xlinkHref: "#glyph-6-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 408.72968,
    xlinkHref: "#glyph-6-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 412.06436,
    xlinkHref: "#glyph-6-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 415.14505,
    xlinkHref: "#glyph-6-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 418.47974,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 419.76151,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 421.04773,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 422.33173,
    xlinkHref: "#glyph-6-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 425.66644,
    xlinkHref: "#glyph-6-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 429.2598,
    xlinkHref: "#glyph-6-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 432.08182,
    xlinkHref: "#glyph-6-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 435.9292,
    xlinkHref: "#glyph-6-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 437.2132,
    xlinkHref: "#glyph-6-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 440.54788,
    xlinkHref: "#glyph-6-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 443.8826,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 445.16434,
    xlinkHref: "#glyph-6-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 446.45059,
    xlinkHref: "#glyph-6-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 447.73459,
    xlinkHref: "#glyph-6-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 451.58197,
    xlinkHref: "#glyph-6-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 454.91666,
    xlinkHref: "#glyph-6-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 457.99734,
    xlinkHref: "#glyph-6-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 461.33203,
    xlinkHref: "#glyph-6-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.56,
    y: 464.66675,
    xlinkHref: "#glyph-6-4"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77.184 546.43h-4.6875v1.5391h4.6875zm1.5976 3.1328h-14.148v-1.5547h6.2539v-1.5898h-6.2578v-1.5781h14.152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.781 543.27h-1.5586v-1.5547h-4.7266v1.5312h-1.5781v-1.5312h-4.7305v1.5352h-1.582v-3.1289h14.176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.609 554.29v-3.1484h14.172v3.1484h-1.5742v-1.5586h-11.027v1.5586"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m38.621 32.562c0.21484 0.0703 0.40234 0.125 0.58984 0.1914 0.0898 0.0352 0.14063 0.0117 0.20703-0.0508 0.41797-0.41797 0.83985-0.82812 1.2578-1.2422l0.082-0.0977c-0.21875-0.0391-0.42188-0.082-0.625-0.10938l-0.1836 0.0625c-0.24219 0.21485-0.47656 0.44141-0.71484 0.66407-0.19531 0.1875-0.39453 0.375-0.61328 0.58203m2.0078-16.117c-0.22656-0.0664-0.41406-0.12109-0.59375-0.18359l-0.19922 0.0469c-0.43359 0.44141-0.875 0.875-1.3125 1.3125l-0.0703 0.0859c0.24609 0.043 0.47656 0.0898 0.71094 0.125l0.0937-0.0391c0.44921-0.4375 0.89843-0.87891 1.3711-1.3477m-3.5234 15.469c0.21485 0.10547 0.45703 0.21484 0.69141 0.33203l0.18359-0.0273c0.375-0.35157 0.75391-0.69922 1.1289-1.0508l0.16406-0.15625c-0.30078-0.11719-0.58203-0.23047-0.86719-0.33985l-0.10937 0.0195c-0.39844 0.40235-0.79297 0.8125-1.1914 1.2227m2.8789-13.863c0.26172 0.10156 0.52344 0.20312 0.78125 0.3125l0.19531-0.0391c0.36719-0.3711 0.74219-0.73829 1.1133-1.1055l0.08602-0.09751c-0.26953-0.125-0.52344-0.25-0.78125-0.36328l-0.14063 0.0312c-0.13281 0.11328-0.2539 0.23828-0.375 0.36328-0.28906 0.29688-0.57812 0.59375-0.8789 0.89844m-2.1016 12.375c-0.27344-0.16406-0.56641-0.33985-0.85938-0.51953l-0.1875 0.0234c-0.34375 0.34375-0.6875 0.6836-1.0352 1.0274l-0.0703 0.082c0.31641 0.21875 0.625 0.42578 0.9375 0.64062 0.40625-0.42187 0.8086-0.83593 1.2148-1.2539m3.4531-11.805c0.30859 0.1875 0.62891 0.38281 0.95703 0.58203 0.42578-0.41015 0.84375-0.8125 1.2695-1.2226-0.33593-0.22266-0.65625-0.4336-0.98437-0.64844-0.41797 0.43359-0.82813 0.85937-1.2422 1.2891m-2.5938 2.6797c0.0156-0.24219 0.0234-0.48047 0.0508-0.71094 0.0117-0.12109-0.0156-0.16016-0.14062-0.17187-0.59375-0.0625-1.1836-0.13282-1.7734-0.20313-0.12109-0.0156-0.26172-0.0977-0.35156-0.0547-0.0937 0.0391-0.13672 0.19141-0.20313 0.29688-0.10937 0.18359-0.21875 0.36719-0.33594 0.5625 0.91407 0.25781 1.8242 0.30078 2.7539 0.28125m-5.7227-3.5156-0.0859 0.0977c-1.2266 1.293-1.7656 2.8555-1.8008 4.6055-0.0195 1.1641 0.19921 2.2852 0.60546 3.3672 0.65235 1.7383 1.7031 3.1992 3.0703 4.4453 0.19922 0.18359 0.41015 0.35547 0.58593 0.50781 0.42188-0.40234 0.82813-0.78906 1.2461-1.1875l-0.15625-0.12891c-1.0312-0.8125-1.8828-1.7852-2.5352-2.9258-0.65234-1.1445-1.0664-2.3633-1.1211-3.6875-0.0391-1.0625 0.15625-2.0664 0.70312-2.9883 0.19141-0.3164 0.41797-0.60547 0.70313-0.88672 0.41797 0.41407 0.82422 0.82032 1.2266 1.2188v-3.5938h-3.6016c0.39453 0.39453 0.77344 0.77344 1.1602 1.1562m9.6328 6.0703c0.14843-0.33985 0.29297-0.66016 0.4414-0.99219-0.44531-0.25781-0.88281-0.51563-1.332-0.77735 0.15625-0.13671 0.30078-0.26171 0.44531-0.38671 0.48047 0.3164 0.94532 0.625 1.4258 0.9414 0.16015-0.3125 0.3164-0.62109 0.47656-0.93359-0.41406-0.23438-0.81641-0.46485-1.2266-0.69531l0.13671-0.25391c-0.22265-0.13281-0.43359-0.26172-0.64843-0.38672-0.125-0.0742-0.26172-0.20703-0.37891-0.19531-0.11719 0.0117-0.22266 0.17578-0.32812 0.27344l-0.22657 0.21093c-0.21875 0.20703-0.4375 0.41407-0.66406 0.625-0.14453-0.125-0.28125-0.23828-0.41016-0.36328l-0.0742-0.16797c-8e-3 -0.17187 0-0.34375 0-0.5h-1.2305c0.0234 0.45313 0.0469 0.88672 0.0664 1.3281h-3.668v1.1484h3.7734c0.0274 0.1875 0.0469 0.33984 0.0664 0.49218-0.10547 0.0352-0.19531 0.0664-0.29297 0.10157 0.0664 0.29687 0.12891 0.57812 0.19531 0.875h-2.168l-0.0273-0.19922c0.61719-0.11719 1.2148-0.23047 1.8281-0.34766-0.0391-0.24609-0.0703-0.47656-0.10546-0.71875-0.69922 0.0859-1.375 0.16797-2.0625 0.25391 0.0195 0.13281 0.0351 0.2539 0.0586 0.40625h-1.2266c0.18359 0.91015 0.36328 1.7891 0.54297 2.6758 0.44531-0.0156 0.87109-0.0312 1.3164-0.0469-0.0547-0.27734-0.10937-0.53906-0.16406-0.8164h2.6289v0.74609l-0.1875 0.0234c-0.88282 0.10547-1.7734 0.19531-2.6562 0.32031-0.45704 0.0625-0.88672 0.23047-1.2344 0.55469-0.48828 0.44922-0.4375 1.0469 0.13672 1.375 0.26172 0.14844 0.56641 0.22265 0.85156 0.32812 0.10938 0.0391 0.20703 8e-3 0.3125-0.0352 0.33985-0.15625 0.6836-0.30078 1.0234-0.44922l0.11328-0.0547c-0.1875-0.082-0.37109-0.14844-0.53906-0.24219l-0.19531-0.1875 0.23046-0.14843c0.29297-0.0781 0.59375-0.15235 0.89454-0.19922 0.38671-0.0586 0.77734-0.0898 1.2031-0.13672v1.3242h1.2656c-0.0195-0.44922-0.0352-0.88282-0.0508-1.3281 0.49219 0.0195 0.96875 0.0391 1.4453 0.0625l0.0898 0.0937c0.0273 0.15625 0.0391 0.31641 0.0625 0.47656 0.0312 0.21875 0.0742 0.4375 0.11328 0.67579 0.46485-0.17188 0.89844-0.33204 1.332-0.49219-0.28515-1.293-0.42187-2.5859-0.46093-3.9141h-3.8242l-4e-3 -0.0312c0.45703-0.1836 0.91797-0.36719 1.3828-0.55469-0.0781-0.27735-0.15234-0.54297-0.23047-0.8125-0.16796 0.0469-0.32031 0.0859-0.48437 0.13281-0.0156-0.25-0.0312-0.47656-0.0469-0.73437 0.78125 0.5664 1.5312 1.1094 2.2891 1.6562m-1.7969 9.2109h-9.75v-17.094h7.168l-0.0937 0.11719c-0.52344 0.52734-1.0469 1.0508-1.5742 1.5703l-0.14062 0.0664 0.0547 0.0625c0.2461-0.0352 0.4961-0.0625 0.74219-0.0977l0.12891-0.0781c0.5-0.49219 0.99609-0.98047 1.4961-1.4688l0.0703-0.0898c-0.17968-0.0273-0.34765-0.0547-0.51171-0.082h9.6953v9.8359l-0.0234-0.0937c-0.0664-0.94531-0.30469-1.8516-0.64844-2.7305-0.72265-1.8438-1.9141-3.3476-3.4102-4.625l-0.19532-0.15625c-0.42187 0.41797-0.83203 0.82422-1.2461 1.2344l8e-3 0.0156 0.0977 0.082c0.76953 0.60157 1.4453 1.3008 2.0156 2.0938 0.98047 1.3672 1.6172 2.8633 1.6875 4.5664 0.0508 1.2383-0.23046 2.3789-0.98046 3.3828-0.11329 0.15235-0.23829 0.28906-0.38282 0.46094-0.41797-0.41797-0.8164-0.82031-1.2266-1.2344v3.6094h3.6523c-0.41796-0.41797-0.80859-0.80859-1.1992-1.1992l0.0469-0.0547c0.82422-0.85547 1.3594-1.8633 1.6211-3.0156 0.0781-0.35156 0.1211-0.70703 0.1836-1.0586v5.9805h-7.2031l0.0977-0.11718c0.50781-0.50782 1.0156-1.0117 1.5234-1.5156l0.1289-0.14062c-0.26953 0.0352-0.5039 0.0625-0.73437 0.0977l-0.10938 0.082c-0.47265 0.46875-0.9414 0.9375-1.4102 1.4102l-0.0899 0.0977c0.17969 0.0312 0.34375 0.0586 0.51172 0.0859",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.141 27.086c-0.0625 0.35157-0.10547 0.70704-0.1836 1.0586-0.26171 1.1523-0.79687 2.1602-1.6211 3.0117l-0.0469 0.0586c0.39062 0.39063 0.78125 0.77734 1.1992 1.1953h-3.6523v-3.6055c0.41016 0.41407 0.80859 0.8125 1.2266 1.2344 0.14453-0.17188 0.26953-0.30859 0.38282-0.46094 0.75-1.0039 1.0312-2.1445 0.98046-3.3828-0.0703-1.7031-0.70703-3.1992-1.6875-4.5664-0.57031-0.79297-1.2422-1.4922-2.0156-2.0976l-0.0977-0.082-8e-3 -0.0117c0.41406-0.41016 0.82422-0.81641 1.2461-1.2344l0.19532 0.15625c1.4961 1.2774 2.6875 2.7812 3.4102 4.625 0.34375 0.87891 0.58203 1.7852 0.65235 2.7305l0.0195 0.0937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.445 15.973c0.16406 0.0273 0.33203 0.0547 0.51171 0.082l-0.0703 0.0898c-0.5 0.48828-0.99609 0.97656-1.4961 1.4688l-0.12891 0.0781c-0.24609 0.0352-0.49609 0.0625-0.74219 0.0937l-0.0547-0.0586 0.14062-0.0664c0.52735-0.51953 1.0508-1.043 1.5742-1.5703l0.0937-0.11719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.855 33.066c-0.16797-0.0273-0.33203-0.0547-0.51172-0.0859l0.0899-0.0977c0.46875-0.47266 0.9414-0.94141 1.4102-1.4102l0.11328-0.082c0.22657-0.0352 0.46094-0.0625 0.73047-0.0977l-0.1289 0.14062c-0.50782 0.50391-1.0156 1.0078-1.5234 1.5156l-0.0977 0.11718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.023 26.109h1.3828v-0.70703h-1.418c0.0117 0.23828 0.0234 0.46484 0.0352 0.70703m1.6289-2.2539c-0.75782-0.54688-1.5078-1.0898-2.2891-1.6562 0.0156 0.25781 0.0312 0.48437 0.0469 0.73437 0.16406-0.0469 0.31641-0.0898 0.48437-0.13281 0.0781 0.26953 0.15235 0.53515 0.23047 0.80859-0.46484 0.1875-0.92578 0.375-1.3828 0.5586l4e-3 0.0312h3.8242c0.0391 1.3281 0.17578 2.6211 0.46093 3.9141-0.43359 0.16015-0.86718 0.32031-1.332 0.49219-0.0391-0.23829-0.082-0.45704-0.11328-0.67969-0.0234-0.15625-0.0352-0.31641-0.0625-0.47266l-0.0898-0.0937c-0.47657-0.0234-0.95313-0.043-1.4453-0.0625 0.0156 0.44531 0.0312 0.87891 0.0508 1.3281h-1.2656v-1.3281c-0.42578 0.0469-0.81641 0.082-1.2031 0.14063-0.30079 0.0469-0.60157 0.12109-0.89454 0.19531l-0.23046 0.15234 0.19531 0.1875c0.16797 0.0937 0.35156 0.16016 0.53906 0.24219l-0.11328 0.0547c-0.33984 0.14844-0.68359 0.29297-1.0234 0.44531-0.10547 0.0469-0.20312 0.0781-0.3125 0.0391-0.28515-0.10547-0.58984-0.17968-0.85156-0.32812-0.57422-0.32813-0.625-0.92578-0.13672-1.3789 0.34766-0.32031 0.77734-0.48828 1.2344-0.55078 0.88281-0.125 1.7734-0.21484 2.6562-0.32422l0.1875-0.0195v-0.74609h-2.6289c0.0586 0.27734 0.10937 0.53515 0.16406 0.8164-0.44531 0.0156-0.87109 0.0312-1.3164 0.0469-0.17969-0.88672-0.35938-1.7656-0.54297-2.6797h1.2266c-0.0234-0.14844-0.0391-0.27344-0.0586-0.40234 0.6875-0.0859 1.3633-0.16797 2.0625-0.25391 0.0351 0.23828 0.0664 0.47266 0.10546 0.71875-0.61328 0.11719-1.2109 0.23047-1.8281 0.34766l0.0273 0.19922h2.168c-0.0664-0.29688-0.1289-0.57813-0.19531-0.875 0.0977-0.0352 0.1875-0.0664 0.29297-0.10157-0.0195-0.15625-0.0391-0.30468-0.0664-0.49218h-3.7734v-1.1484h3.668c-0.0195-0.44141-0.043-0.875-0.0664-1.3281h1.2305c0 0.15625-8e-3 0.32813 0 0.5l0.0742 0.16797c0.12891 0.125 0.26563 0.23828 0.41016 0.36328 0.22656-0.21093 0.44531-0.41797 0.66406-0.625l0.22657-0.21093c0.10546-0.0977 0.21093-0.26172 0.32812-0.27344 0.11719-0.0117 0.25391 0.12109 0.37891 0.19531 0.21484 0.125 0.42578 0.25391 0.64843 0.38672l-0.13671 0.25c0.41015 0.23437 0.8125 0.46094 1.2266 0.69922-0.16016 0.3125-0.31641 0.62109-0.47656 0.93359-0.48047-0.3164-0.94532-0.625-1.4258-0.9414-0.14453 0.125-0.28906 0.25-0.44531 0.38671 0.44922 0.26172 0.88672 0.51954 1.332 0.77735-0.14843 0.33203-0.29297 0.65234-0.4414 0.99219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.02 17.785c-0.38671-0.38672-0.76562-0.76172-1.1602-1.1562h3.6016v3.5938c-0.40234-0.40234-0.80859-0.80468-1.2266-1.2188-0.28516 0.28125-0.51172 0.56641-0.70313 0.88672-0.54687 0.92188-0.74218 1.9258-0.69922 2.9883 0.0508 1.3242 0.46485 2.543 1.1172 3.6875 0.65235 1.1406 1.5078 2.1133 2.5352 2.9219l0.15625 0.13281c-0.41797 0.39453-0.82422 0.78125-1.2461 1.1836-0.17578-0.14843-0.38671-0.32031-0.58593-0.5039-1.3672-1.2461-2.418-2.707-3.0703-4.4453-0.40625-1.082-0.625-2.207-0.60546-3.3672 0.0351-1.7539 0.57421-3.3125 1.8008-4.6055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.742 21.301c-0.92969 0.0195-1.8398-0.0234-2.7539-0.28125 0.11719-0.19922 0.22657-0.37891 0.33594-0.5625 0.0664-0.10547 0.10938-0.25781 0.20313-0.30078 0.0898-0.0391 0.23047 0.043 0.35156 0.0586 0.58984 0.0703 1.1797 0.14063 1.7734 0.20313 0.125 0.0117 0.15234 0.0508 0.14062 0.17187-0.0273 0.23047-0.0351 0.46875-0.0508 0.71094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.336 18.621c0.41406-0.42969 0.82422-0.85547 1.2422-1.2891 0.32812 0.21484 0.64844 0.42578 0.98437 0.64844-0.42578 0.41015-0.84375 0.8125-1.2695 1.2226-0.32812-0.19922-0.64844-0.39844-0.95703-0.58203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.883 30.426c-0.40625 0.41797-0.8086 0.83203-1.2148 1.2539-0.3125-0.21484-0.62109-0.42187-0.9375-0.64062l0.0703-0.082c0.34766-0.34375 0.69141-0.6836 1.0352-1.0274l0.1875-0.0273c0.29297 0.18359 0.58594 0.35938 0.85938 0.52344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.984 18.051c0.30078-0.3086 0.58984-0.60547 0.8789-0.89844 0.1211-0.125 0.24219-0.25 0.375-0.36719l0.14063-0.0273c0.25781 0.11328 0.51172 0.23437 0.78125 0.36328l-0.0859 0.0977c-0.37109 0.36718-0.74609 0.73047-1.1133 1.1016l-0.19531 0.043c-0.25781-0.10938-0.51953-0.21094-0.78125-0.3125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.105 31.914c0.39844-0.41016 0.79297-0.82031 1.1914-1.2227l0.10937-0.0195c0.28516 0.10547 0.56641 0.21875 0.86719 0.33985l-0.16406 0.15625c-0.375 0.34765-0.75391 0.69531-1.1289 1.0508l-0.18359 0.0273c-0.23438-0.11719-0.47656-0.23047-0.69141-0.33203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.629 16.445c-0.47266 0.46875-0.92188 0.91016-1.3711 1.3477l-0.0937 0.0391c-0.23438-0.0352-0.46485-0.082-0.71094-0.125l0.0703-0.0859c0.4375-0.4375 0.87891-0.87109 1.3125-1.3125l0.19922-0.0469c0.17969 0.0625 0.36719 0.11718 0.59375 0.18359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.621 32.562c0.21875-0.20703 0.41797-0.39453 0.61328-0.58203 0.23828-0.22266 0.47265-0.44922 0.71484-0.66407l0.1836-0.0625c0.20312 0.0273 0.40625 0.0703 0.625 0.10938l-0.082 0.0977c-0.41796 0.41407-0.83984 0.82422-1.2578 1.2422-0.0664 0.0625-0.11719 0.0859-0.20703 0.0508-0.1875-0.0664-0.375-0.12109-0.58984-0.1914"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m41.023 26.109c-0.0117-0.24219-0.0234-0.46875-0.0352-0.70703h1.418v0.70703",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.88 502.73 1.1758 1.2226-0.59766 0.0156 0.0156 2.1094 0.0625 0.1836c0.0352 0.10156 0.10156 0.23437 0.14453 0.29687 0.26563 0.38282 0.75391 0.47266 1.2656 0.23828 0.0742-0.0352 0.69531-0.38671 1.375-0.78125 0.68359-0.39453 1.25-0.71484 1.2617-0.70312l0.52735 0.9375c-8e-3 8e-3 -0.5625 0.32422-1.2344 0.71875-1.375 0.79297-1.5 0.85937-1.8164 0.96484-1.2188 0.41016-2.2148-0.082-2.5547-1.2578-0.10156-0.35937-0.10547-0.39453-0.12109-1.5664l-0.0117-1.1289-0.6836-0.0195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.43 498.66c0.13282-0.76954 0.5-1.3242 1.043-1.5859 0.23047-0.11328 0.38672-0.14844 0.69922-0.16016 0.32031-0.0156 0.54297 0.0195 0.89063 0.13672 0.29687 0.0977 0.52734 0.21875 1.3281 0.68359 0.36719 0.21094 0.67188 0.38282 0.67188 0.37891l0.3164-0.50781 0.46094 1.6328-1.6367 0.39844 0.26563-0.58203c-0.0937-0.0664-1.4258-0.82813-1.543-0.87891-0.19531-0.0898-0.39453-0.125-0.58203-0.11328-0.40235 0.0234-0.66407 0.24219-0.8086 0.67187l-0.0586 0.17188-8e-3 1.5586-4e-3 1.5625h-1.0781v-1.5703c4e-3 -1.4062 8e-3 -1.5977 0.043-1.7969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.9 499.21c0.0195-0.0234 2.3711 1.3281 2.6328 1.5078 0.28516 0.19922 0.59375 0.5 0.76172 0.7461 0.10156 0.14843 0.23438 0.4414 0.28125 0.6289 0.1211 0.47656-4e-3 1.0312-0.33203 1.4727-0.16016 0.21875-0.50781 0.54297-0.75781 0.70703-0.1211 0.0781-0.53516 0.32812-0.92188 0.55078-0.39062 0.22266-0.71093 0.40625-0.71484 0.41016l0.28125 0.52734-1.6406-0.41406 0.46094-1.6211 0.35156 0.54297c0.0312 0 1.4727-0.83593 1.6172-0.9375 0.36719-0.26172 0.5586-0.64453 0.49219-0.98437-0.0547-0.26953-0.23828-0.53516-0.5-0.71485-0.0664-0.0508-0.66016-0.40234-1.3242-0.78515-0.66016-0.38281-1.2031-0.70313-1.207-0.71485 0.15625-0.3164 0.32812-0.6289 0.51953-0.92187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.51 502.21h-0.50781v-1.9648h0.37891l0.7539 0.69531c0.51953 0.48047 0.65625 0.5625 0.90235 0.5625 0.25 0 0.40625-0.17187 0.40625-0.49219 0-0.33984-0.12891-0.57812-0.2461-0.69921v-8e-3h0.61719c0.082 0.13672 0.1875 0.41407 0.1875 0.78907 0 0.65625-0.375 1.0586-0.91406 1.0586-0.41797 0-0.70703-0.17578-1.2266-0.69531l-0.35156-0.35547v1.0859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.51 504.51h-0.50781v-1.9688h0.37891l0.7539 0.69922c0.51953 0.48047 0.65625 0.5586 0.90235 0.5586 0.25 0 0.40625-0.16797 0.40625-0.49219 0-0.33984-0.12891-0.57813-0.2461-0.69531v-0.0117h0.61719c0.082 0.13672 0.1875 0.41406 0.1875 0.79297 0 0.65234-0.375 1.0547-0.91406 1.0547-0.41797 0-0.70703-0.17187-1.2266-0.69531l-0.35156-0.35156v1.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.367 500.04-0.0195 0.20313c0 0.3164 0.15625 0.50781 0.42187 0.50781 0.25782 0 0.39454-0.17969 0.39454-0.46875 0-0.11719-0.0117-0.19922-0.0234-0.24219zm1.0664-0.41797c0.0273 0.15235 0.0469 0.35938 0.0469 0.64453 0 0.30469-0.0625 0.53125-0.18359 0.67579-0.11328 0.13671-0.29297 0.22656-0.50781 0.22656-0.21875 0-0.39844-0.0664-0.52344-0.19922-0.16406-0.16406-0.24219-0.42969-0.24219-0.72656l0.0117-0.20313h-0.86328v-0.41797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.137 502.56 0.56641-0.17969c0.14062-0.043 0.29687-0.082 0.42969-0.11719v-4e-3c-0.13282-0.0352-0.29297-0.0703-0.42969-0.11328l-0.56641-0.17578zm-0.3164-0.65625-0.64844-0.19922v-0.4336l2.293 0.73828v0.53516l-2.293 0.74609v-0.44921l0.64844-0.20704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.367 504.19-0.0195 0.20703c0 0.3125 0.15625 0.50391 0.42187 0.50391 0.25782 0 0.39454-0.17969 0.39454-0.46875 0-0.11719-0.0117-0.19922-0.0234-0.24219zm1.0664-0.41797c0.0273 0.15235 0.0469 0.35938 0.0469 0.64453 0 0.30469-0.0625 0.53125-0.18359 0.67579-0.11328 0.13671-0.29297 0.22656-0.50781 0.22656-0.21875 0-0.39844-0.0664-0.52344-0.19922-0.16406-0.16406-0.24219-0.42969-0.24219-0.72266l0.0117-0.20703h-0.86328v-0.41797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.4 256.02h-11.961v-2.0156h11.961zm-0.50391 14.738c0.54688 0.6211 0.74219 1.3633 0.74219 2.3203 0 0.95312-0.19531 1.6914-0.74219 2.3164-0.85546 0.99219-2.3047 1.5195-5.5 1.5195-3.1914 0-4.6406-0.52734-5.5-1.5195-0.54687-0.625-0.73828-1.3633-0.73828-2.3164 0-0.95703 0.19141-1.6992 0.73828-2.3203 0.85938-0.97656 2.3086-1.5195 5.5-1.5195 3.1953 0 4.6445 0.54297 5.5 1.5195m-3.832 25-0.043 0.0312-4.8203-1.7578 4.8633-1.7656zm-1.6211 4.8086v1.8867h-6.0078v-1.6524c0-1.5312 0.89062-2.3125 2.8789-2.3125 1.8789 0 3.0234 0.75782 3.1289 2.0781m1.6211 11.414-0.043 0.0273-4.8203-1.7539 4.8633-1.7695zm1.0352-66.184c1.9844 0 3.3008 1.168 3.3008 4.0898v2.1523h-5.8867v-0.77734c0-1.4805 0.76172-2.3164 1.9883-2.3164v-0.27343h-4.5039v0.27343c1.2656 0 2.0391 0.83594 2.0391 2.3164v0.77734h-5.5977v-2.2188c0-2.2773 1.1367-3.1914 2.8477-3.1914v-0.27735h-3.3281v11.902l9.5508 3.2969-9.5508 3.5547v3.8438h0.48047v-1.5859h4.1562c-2.8398 0.6875-4.918 2.957-4.918 5.7148 0 2.8594 2.2461 5.1992 5.2578 5.7812h-4.4961v-1.668h-0.48047v5.2812h0.48047v-1.6719h5.5977v5.6719h-5.5977v-1.668h-0.48047v5.2812h0.48047v-1.668h11.73l-12.406 4.5156-0.0742 0.0273v0.32031l8.3203 3.0274-0.0156 0.0156c-0.55078 0.39453-0.94922 0.94922-1.1953 1.6602-0.14063 0.38672-0.23047 0.82031-0.27344 1.293-0.0234-0.082-0.0508-0.17188-0.082-0.26563-0.15234-0.47656-0.38672-1.0117-0.74219-1.4922-0.62109-0.83593-1.4258-1.2617-2.3867-1.2617-1.4297 0-2.4883 0.83985-3.0039 2.2891-0.21094 0.59765-0.33203 1.2969-0.35157 2.082v5.8867h0.47657v-1.8555h11.68l-12.352 4.4961-0.0742 0.0234v0.32422l8.5195 3.1016 0.35157 0.125 0.37109 0.13281v4e-3c1.3867 0.53125 2.2852 1.082 2.8398 1.8438 0.55079 0.76562 0.62891 1.7461 0.62891 3.1367v1.3828l-12.09-6.9766-0.35157-0.20703v9.2266h4.6797v-0.35156h-0.0898c-1.2617 0-2.2031-0.41016-2.957-1.1602-0.375-0.375-0.66407-0.80859-0.85547-1.3125-0.19531-0.5-0.30078-1.0664-0.30078-1.6797v-1.8945l12.09 6.9805 0.35547 0.20313v-10.035h-4.3203v-3.7188l3.8398-1.3984v1.5938h0.48047v-7.9141h-0.48047v1.8672h-5.6016v-2.2734c0-1.0273 0.42578-2.2539 2.3555-2.2539h1.168c1.0703 0 2.8672-0.36328 2.8672-2.8125 0-0.67578-0.18359-1.2109-0.53125-1.5508l-0.0625-0.0664-0.25 0.21484 0.0586 0.0703c0.17968 0.23047 0.32422 0.41406 0.32422 0.85938 0 0.64453-0.6211 1.0312-1.6562 1.0312h-0.94922c-0.38672 0-0.94532 0.0547-1.5274 0.30859v4e-3l-0.0351-0.0117v-3.8906l3.8398-1.3984v1.5938h0.48047v-5.8047h-4e-3v-1.668h-0.47656v1.668h-5.8867v-5.6719h5.8867v1.6719h0.47656v-5.2812h-0.47656v1.668h-4.543c3.0156-0.58203 5.2578-2.9219 5.2578-5.7812 0-2.7578-2.0742-5.0274-4.918-5.7148h4.2031v1.6406h0.47656v-3.7578h-0.47656v1.6406h-11.59l12.375-4.5195v-0.0586l-12.602-4.3438h11.816v1.7148h0.47656v-14.156h-3.7773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.96 289.21v-0.0156l-1.9336-1.2305v-1.0547l2.0703 1.3125 2.7578-1.4609v1.0938l-1.9805 0.99609 0.54687 0.35938h1.4336v0.97265h-4.8281v-0.97265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.02 286.34h4.8281v-0.97265h-4.8281z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.14 283.02c0-0.17187-0.0312-0.30859-0.0898-0.41406-0.0586-0.10156-0.15625-0.1875-0.28906-0.24609-0.13672-0.0625-0.3125-0.10157-0.53516-0.1211-0.21875-0.0234-0.49609-0.0312-0.82422-0.0312-0.27734 0-0.51562 8e-3 -0.72266 0.0274-0.21093 0.0156-0.38281 0.0547-0.51953 0.10937-0.13672 0.0586-0.24218 0.14063-0.3125 0.25-0.0703 0.11328-0.10547 0.25781-0.10547 0.44531v0.41407h3.3984zm-4.1133-0.1914c0-0.33594 0.0547-0.60938 0.16406-0.81641 0.11328-0.20703 0.26953-0.37109 0.47657-0.48437 0.20312-0.11719 0.44921-0.19141 0.73828-0.23438 0.28906-0.0391 0.61328-0.0625 0.96875-0.0625 0.42187 0 0.79297 0.0273 1.1055 0.0781 0.3125 0.0547 0.57031 0.14453 0.77343 0.26953 0.20313 0.125 0.35547 0.29687 0.45313 0.50781 0.10156 0.21094 0.14844 0.48047 0.14844 0.80469v1.5352h-4.8281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.48 279.65c0.11328 0 0.21484-0.0117 0.30859-0.0273 0.0937-0.0195 0.17188-0.0547 0.23438-0.10156l0.14843-0.20313c0.0352-0.082 0.0547-0.18359 0.0547-0.3125 0-0.14844-0.0508-0.28125-0.14453-0.40234-0.0977-0.1211-0.24609-0.17969-0.44922-0.17969-0.10937 0-0.20312 0.0156-0.28125 0.043l-0.21484 0.14453c-0.0625 0.0703-0.1211 0.16016-0.17188 0.26953-0.0508 0.10938-0.10547 0.2461-0.16015 0.41016-0.0703 0.21484-0.15235 0.40234-0.23828 0.5625-0.082 0.15625-0.1836 0.28906-0.29688 0.39453-0.11719 0.10547-0.25 0.18359-0.40234 0.23437-0.14844 0.0469-0.32422 0.0742-0.52344 0.0742-0.47656 0-0.83203-0.13281-1.0703-0.40234-0.23047-0.26563-0.35157-0.62891-0.35157-1.0938 0-0.21875 0.0234-0.41797 0.0742-0.59766 0.0469-0.18359 0.125-0.34375 0.22657-0.47656 0.10937-0.13281 0.24218-0.23437 0.40625-0.30859 0.16796-0.0742 0.36328-0.11328 0.59375-0.11328h0.13281v0.93354c-0.22656 0-0.40235 0.043-0.52735 0.12109-0.125 0.082-0.1875 0.21875-0.1875 0.40625 0 0.10938 0.0156 0.19922 0.0469 0.27344l0.125 0.17188 0.17969 0.0859 0.21093 0.0234c0.14844 0 0.27344-0.0312 0.375-0.0937 0.10157-0.0625 0.19532-0.19922 0.28125-0.40625l0.32422-0.75c0.082-0.18359 0.16407-0.33594 0.25391-0.45312 0.0859-0.11719 0.18359-0.21094 0.28516-0.28125 0.0976-0.0703 0.21093-0.11719 0.33203-0.14454 0.12109-0.0273 0.25781-0.043 0.40625-0.043 0.51172 0 0.88281 0.14843 1.1133 0.44531 0.23437 0.29297 0.34765 0.70703 0.34765 1.2344 0 0.55078-0.11718 0.94141-0.35937 1.1797-0.23828 0.23828-0.57813 0.35547-1.0273 0.35547h-0.19532v-0.97266"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m117.47 7.9141 4e-3 17.617c0 5.0469-4.1524 9.1562-9.2578 9.1562l-53.105 8e-3v-17.621c0-5.0469 4.1524-9.1523 9.2578-9.1523",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m57.238 21.172v11.398l31.848-8e-3c3.9336 0 7.1328-3.1524 7.1328-7.0274l-4e-3 -11.398-31.844 8e-3c-3.9336 0-7.1328 3.1523-7.1328 7.0273",
    fill: "#231f20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m57.945 21.172c0-3.4844 2.8828-6.3203 6.4258-6.3203l31.137-4e-3v10.688c0 3.4844-2.8828 6.3203-6.4219 6.3203l-31.137 4e-3",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m64.371 14.141c-3.9336 4e-3 -7.1328 3.1562-7.1328 7.0312v11.395h22.68l-4.543-9.2109 4.5391-9.2148",
    fill: "#231f20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m57.945 21.172c0-3.4844 2.8828-6.3203 6.4258-6.3203l14.406-4e-3 -4.1914 8.5078 4.1914 8.5-20.828 4e-3",
    fill: "#231f20"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.285 27.438v-0.45313l-0.0117-0.10547c2.3516 0.21094 5.9727 0.53516 7.6133 0.69141 0.16406 0.0195 0.3125-0.10547 0.32813-0.27344 0.0195-0.16797-0.10547-0.3164-0.27344-0.33203-2.5195-0.24219-9.7109-0.87891-9.7852-0.88672-0.12109-0.0117-0.21875-0.1289-0.21875-0.26953v-4.9102c0-0.13671 0.0977-0.2539 0.21875-0.26562 0.0742-8e-3 7.2656-0.64844 9.7852-0.89063 0.16797-0.0156 0.29297-0.16015 0.27344-0.33203-0.0156-0.16797-0.16407-0.28906-0.33203-0.27343-1.6367 0.15625-5.2578 0.48437-7.6094 0.69531l0.0117-0.10938v-0.44922c0-0.28906-0.23438-0.52734-0.52734-0.52734h-1.9024c-0.29297 0-0.52734 0.23828-0.52734 0.52734v0.44922c0 0.21875 0.13281 0.41016 0.32422 0.48828-0.19922 0.16016-0.32422 0.41016-0.32422 0.6875v4.9102c0 0.28125 0.1289 0.52734 0.32422 0.69141-0.19141 0.0781-0.32422 0.26562-0.32422 0.48437v0.45313c0 0.28906 0.23437 0.52734 0.52734 0.52734h1.9024c0.29296 0 0.52734-0.23828 0.52734-0.52734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.668 27.742v-0.52734l0.6211-0.71094c0.13671-0.15625 0.21093-0.38281 0.21093-0.625v-5.0508c0-0.24219-0.0781-0.46875-0.21093-0.62109l-0.625-0.71485v-0.52734c0-0.33203-0.28125-0.60156-0.63282-0.60156h-0.80078c-0.11328 0-0.22265 0.0273-0.32031 0.082l-0.10156 0.0937c-0.0664 0.0977-0.10157 0.21094-0.10157 0.32422l4e-3 8.9805c0 0.11328 0.0312 0.22656 0.0977 0.32422l0.10156 0.0937c0.0977 0.0547 0.21094 0.082 0.32031 0.082h0.80469c0.34766 0 0.63281-0.26953 0.63281-0.60157m-1.3633 8e-3 -4e-3 -8.793h0.73047l0.0391 8e-3v0.63672l0.0742 0.19531 0.69922 0.80078c0.0312 0.0352 0.0625 0.1211 0.0625 0.23047v5.0508c0 0.10938-0.0312 0.19532-0.0625 0.23047l-0.69922 0.80078-0.0742 0.19532v0.63671l-0.0352 8e-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.629 25.879v-5.0469c0-0.14063-0.11328-0.25391-0.25-0.25391-0.14063 0-0.25391 0.11328-0.25391 0.25391l4e-3 5.0469c0 0.13672 0.10937 0.25 0.25 0.25 0.13672 0 0.25-0.11328 0.25-0.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.863 25.828c0.15235-0.0664 0.22266-0.23828 0.16016-0.39453-0.0625-0.15234-0.23828-0.22266-0.39062-0.16016-0.25391 0.10547-0.51954 0.15625-0.79688 0.15625-1.1445 0-2.0742-0.92968-2.0742-2.0742 0-1.1445 0.92969-2.0781 2.0742-2.0781s2.0781 0.93359 2.0781 2.0781v0.0234l-0.42969-0.42968c-0.11719-0.11719-0.3086-0.11719-0.42578 0l-0.0859 0.21484 0.0859 0.21094 0.9414 0.9414c0.1211 0.11719 0.3086 0.11719 0.42578 0l0.94141-0.9414c0.11719-0.11719 0.11719-0.3086 0-0.42578-0.11719-0.11719-0.30469-0.11719-0.42578 0l-0.42969 0.43359 4e-3 -0.0273c-4e-3 -1.4766-1.2031-2.6758-2.6797-2.6758s-2.6758 1.1992-2.6758 2.6758 1.2031 2.6758 2.6758 2.6758c0.35547 0 0.69922-0.0664 1.0273-0.20313"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#040505"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m106.32 24.359c-1.1211-0.75781-2.5938-0.11328-3.3438 0.67578-0.67969 0.71485-0.83984 1.2891-0.85938 1.3633l0.69922 0.36719-2.8828 1.0547-0.60547-2.9805 0.73438 0.39453 0.22656-0.40234c0.81641-1.2539 1.9297-1.5195 2.2773-1.6094 0.59375-0.14843 2.3828-0.37109 3.7539 1.1367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.27 24.348c-1.2383 0.54297-1.4805 2.1328-1.2109 3.1836 0.23438 0.93359 0.62109 1.375 0.69141 1.4492l8e-3 -4e-3 0.6875-0.39844-0.65625 3.0039-2.8398-1.0898 0.71484-0.39843-0.21484-0.39453c-0.625-1.3594-0.25782-2.4453-0.14454-2.7812 0.19141-0.58594 0.95704-2.2188 2.9648-2.5703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.27 29.652c-1.4844-0.21094-2.1992-1.1016-2.4219-1.3789-0.39062-0.48046-1.3476-2.0039-0.5625-3.8867-0.21484 1.3398 0.9961 2.3984 2.0274 2.7461 0.92187 0.30469 1.5039 0.21484 1.5938 0.19922l4e-3 -0.0117 0.0352-0.79688 2.1758 2.168-2.4453 1.8125 0.0469-0.8164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.52 20.551c0-0.6836 0.55469-1.2383 1.2383-1.2383s1.2383 0.55468 1.2383 1.2383c0 0.68359-0.55469 1.2422-1.2383 1.2422s-1.2383-0.5586-1.2383-1.2422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.35 22.246c-4e-3 -4.4766-3.6406-8.1133-8.1172-8.1133-4.4727 0-8.1133 3.6406-8.1133 8.1172 0 0.23828 0.0156 0.47265 0.0351 0.70703l-0.8125 0.0547 1.4336 1.4805 1.2695-1.6602-0.85938 0.0625c-0.0156-0.21094-0.0312-0.42969-0.0312-0.64844 0-0.34375 0.0274-0.67969 0.0742-1.0117l0.21485-0.0352 6.5703-0.76954c1.2383-0.10546 1.4375 0.60157 1.25 1.0391l-0.98828 2.4609c-0.1211 0.28516 0.11718 0.41797 0.11718 0.41797s0.2461 0.16016 0.42579-0.125c0 0 2.2226-3.3555 2.3594-4.0703 0.17969-0.97266-0.60937-1.9375-1.6406-2.1523l-5.832-1.1914c1.2266-1.0234 2.8086-1.6406 4.5274-1.6406 3.9023 0 7.082 3.1719 7.082 7.0781 0 2.0859-0.90625 3.9609-2.3438 5.2578l0.73437 0.72657c1.625-1.4844 2.6445-3.6172 2.6445-5.9844m-10.859-3.6133c0.28906 0.10547 0.26953 0.26562 0.26953 0.26562s0.0312 0.14454-0.26172 0.22266l-4.0625 1.1562c0.28125-0.96484 0.75782-1.8477 1.3906-2.5938"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.156 27.934c-0.38672-0.0234-1.0195-0.0703-1.3125-0.0977-2.6914-0.2539-5.0312-0.8164-6.9609-1.668-0.79688-0.35157-1.5781-0.79688-2.0938-1.1914l1.5508-7.2539c0.14453 0.10938 0.29297 0.21094 0.41015 0.28907 2.1211 1.4062 4.957 2.293 8.1953 2.5625 0.45312 0.0391 1.2188 0.0664 1.7617 0.0703zm0.73438 0.51953 1.7344-8.1445c0.0234-0.125-8e-3 -0.25781-0.0898-0.35547-0.082-0.0977-0.20703-0.15234-0.33594-0.14453l-0.0781 4e-3c-0.39453 0.0234-1.5156-0.0117-2.1055-0.0586-3.0977-0.25781-5.8008-1.0976-7.8086-2.4336-0.23437-0.15234-0.55468-0.38672-0.73046-0.52734l-0.14844-0.11719c-0.11328-0.0898-0.26563-0.11328-0.39453-0.0664-0.13672 0.0469-0.23438 0.16016-0.26563 0.30469l-1.7383 8.1367-8e-3 0.0859c0 0.12109 0.0586 0.24609 0.15234 0.32031l0.12891 0.10547c0.5664 0.45312 1.4414 0.96093 2.3438 1.3594 2.0117 0.89063 4.4414 1.4688 7.2188 1.7344 0.37109 0.0352 1.2812 0.10156 1.5703 0.11718l0.13281 4e-3c0.20313 8e-3 0.37891-0.12891 0.42188-0.32422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.273 24.254h-0.0469l-0.0859 0.19141c-0.0781 0.0742-0.19141 0.10937-0.31641 0.10156-0.23047-0.0156-0.42187-0.18359-0.42187-0.37109v-4e-3l0.082-0.1875c0.0781-0.0703 0.19531-0.10547 0.3164-0.10156 0.23047 0.0195 0.42188 0.18359 0.42579 0.37109zm0.0234 0.35938c0.10156-0.0937 0.15625-0.22266 0.15625-0.35938-4e-3 -0.30859-0.28906-0.57422-0.63672-0.59765-0.18359-0.0156-0.36328 0.043-0.48438 0.16015-0.10156 0.0977-0.16015 0.22266-0.16015 0.35938v4e-3c4e-3 0.30079 0.28906 0.57032 0.63672 0.59375 0.1875 0.0156 0.36718-0.043 0.48828-0.16015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.328 25.215 1.4492-6.6797-0.0977-0.15234-0.15234 0.10156-1.4531 6.6797v0.0234l0.10156 0.1289"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#050606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.758 11.305h-0.23829v0.97656h0.25c0.1875 0 0.29688-0.13281 0.29688-0.5 0-0.31641-0.0977-0.48438-0.30859-0.48438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.078 14.109-0.34766-1.332h-0.21875v1.332h-0.66797v-3.3594h0.96485c0.5664 0 0.90625 0.30469 0.90625 0.99219 0 0.48828-0.16016 0.75782-0.39063 0.88672l0.4375 1.4805zm-1.5547-2.8047h-0.95312v0.80469h0.7539v0.57031h-0.7539v1.4219h-0.65625v-3.3633h1.6094zm2.3906-1.2617h-4.2188c-0.77735 0-1.4024 0.63672-1.4024 1.4023v3.3633l7.0312-4e-3v-3.3594c0-0.77734-0.63672-1.4023-1.4102-1.4023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.715 14.16c-0.35157 0-0.6211-0.0781-0.80078-0.23047-0.17969-0.14843-0.26954-0.41015-0.26954-0.78125v-0.0977h0.67969v0.0898c0 0.17969 0.0312 0.3086 0.10156 0.39844 0.0703 0.082 0.17969 0.13281 0.34766 0.13281 0.12109 0 0.22266-0.0391 0.29297-0.10937 0.0781-0.0742 0.10937-0.17188 0.10937-0.3125 0-0.10157-0.0195-0.1875-0.0508-0.26172-0.0391-0.0664-0.10937-0.12891-0.23047-0.17578-0.39843-0.16407-0.64843-0.27344-0.73828-0.32422-0.10156-0.04688-0.18359-0.11719-0.24218-0.1875-0.0586-0.07031-0.1211-0.16016-0.16016-0.26953-0.0391-0.10156-0.0586-0.21875-0.0586-0.37109 0-0.32031 0.0898-0.55859 0.26953-0.73047 0.17968-0.16797 0.4375-0.25 0.76953-0.25 0.32812 0 0.58984 0.08203 0.76953 0.23047 0.17969 0.15234 0.26953 0.37891 0.26953 0.69141v0.07813h-0.64844c0-0.32812-0.12109-0.5-0.37109-0.5-0.25781 0-0.39063 0.13281-0.39063 0.39062 0 0.12109 0.0312 0.21875 0.082 0.28125 0.0508 0.05859 0.14062 0.11719 0.26953 0.17969l0.51953 0.23047c0.23047 0.08984 0.39062 0.20703 0.48828 0.34766 0.10156 0.14063 0.15234 0.32031 0.15234 0.53906 0 0.69141-0.39062 1.0312-1.168 1.0312zm-1.2695-0.0586h-1.9219v-3.3594l1.8789-0.0039 4e-3 0.55078h-1.1992v0.79297h1.1289v0.55078h-1.1289v0.89844h1.25v0.55078zm2.3672-4.0625h-4.2188c-0.76953 0.0039-1.4102 0.63281-1.4102 1.4141v3.3594h7.0312v-3.3633c0-0.76953-0.63282-1.4102-1.4102-1.4102"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids100X200);
export default __webpack_public_path__ + "static/media/KIDS100x200.caa82dd593458713db196372757d5c91.svg";
export { ForwardRef as ReactComponent };